(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(6071);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ MediaVine; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3863);




// All the ad types/positions there are.
const allAds = [
    "leaderboard",
    "sidebar-atf",
    "sidebar-btf",
    "content-desktop",
    "content-mobile",
    "adhesion-mobile",
    "adhesion-tablet",
    "adhesion-desktop",
    "recipe",
    "auto-insert-sticky",
    "in-image",
    "chicory",
    "zergnet",
    "interstitial-mobile",
    "interstitial-desktop",
    "universal-player-desktop",
    "universal-player-mobile"
];
/**
 * Renders MediaVine ads based on the allowList provided.
 * If the URL parameter '?hide-ads' is present, ads will not be displayed.
 * if there are no members of allowList, ads will not be displayed
 *
 * @param props - Object containing the allowList array.
 * @returns JSX element with MediaVine ads or null if ads are not to be displayed.
 */ const MediaVine = (props)=>{
    const { allowList =[]  } = props;
    const { pageMetaData: { pathName  }  } = (0,hooks_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .useAppState */ .mr)();
    // Remove items that should be allowed from the blockList.
    const blockList = allAds.filter((adType)=>!allowList.includes(adType));
    // Convert the list into a set of data attributes.
    const blockAttributes = blockList.reduce((obj, item)=>({
            ...obj,
            [`data-blocklist-${item}`]: "1"
        }), {});
    // Do not show ads if we have the query string
    // Do not show ads if we have no allowed slots.
    return !pathName.includes("hide-ads") && !!allowList.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "mediavine",
                strategy: "lazyOnload",
                "data-noptimize": "1",
                "data-cfasync": "false",
                src: "//scripts.mediavine.com/tags/the-muse.js"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "mediavine-settings",
                ...blockAttributes
            })
        ]
    }) : null;
};


/***/ }),

/***/ 7155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ AppPageLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _themuse_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9551);
/* harmony import */ var hooks_AppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3863);

/* eslint-disable camelcase */ 


const AppPageLayout = (props)=>{
    const { children , ...restProps } = props;
    const { user  } = (0,hooks_AppContext__WEBPACK_IMPORTED_MODULE_2__/* .useAppState */ .mr)();
    const pageProps = {
        ...restProps,
        user
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_themuse_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        ...pageProps,
        children: children
    });
};


/***/ }),

/***/ 4557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* unused harmony export convertUriToRelativeUrl */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


/**
 * Remove all starting urls that contain themuse.com/
 * We include the trailing slash to exclude instances where the string
 * is url encoded such as within social media.
 */ const convertUriToRelativeUrl = (url)=>{
    let relativeUrl = url.split("themuse.com/").pop();
    if (!relativeUrl.startsWith("http") && !relativeUrl.startsWith("/")) {
        relativeUrl = `/${relativeUrl}`;
    }
    return relativeUrl;
};
/**
 * Creates an anchor <a> element.
 * * Ensures that all urls pointing to themuse are relative
 * * Ensures that relative urls begin with a slash, forcing them to the root.
 * * Adds noopener and noreferer to external links if they do not already have a rel.
 */ const Link = ({ children , href , rel , target , ...restProps })=>{
    const url = convertUriToRelativeUrl(href);
    const targetProps = {
        target: target || url.startsWith("http") ? "_blank" : null,
        rel: rel || url.startsWith("http") ? "noopener noreferrer" : null
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: url,
        ...targetProps,
        ...restProps,
        children: children
    });
};


/***/ }),

/***/ 887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t3": function() { return /* binding */ ResponsiveImage; }
});

// UNUSED EXPORTS: genPilboxURL, getCDNUrl

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(4557);
// EXTERNAL MODULE: ./src/components/RichTextModule.tsx
var RichTextModule = __webpack_require__(3720);
// EXTERNAL MODULE: ./src/components/leadMedia.module.scss
var leadMedia_module = __webpack_require__(1111);
var leadMedia_module_default = /*#__PURE__*/__webpack_require__.n(leadMedia_module);
// EXTERNAL MODULE: ./src/components/responsiveImageModule.module.scss
var responsiveImageModule_module = __webpack_require__(1536);
var responsiveImageModule_module_default = /*#__PURE__*/__webpack_require__.n(responsiveImageModule_module);
;// CONCATENATED MODULE: ./src/components/Caption.tsx






const Citation = (props)=>{
    const { credit , creditLink  } = props;
    return credit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("cite", {
        children: creditLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
            href: creditLink,
            target: "_blank",
            children: credit
        }) : credit
    }) : null;
};
const Caption = (props)=>{
    const { caption , credit , creditLink  } = props;
    const Cite = /*#__PURE__*/ (0,jsx_runtime.jsx)(Citation, {
        credit,
        creditLink
    });
    const Cap = /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule/* RichTextModule */.n, {
        type: undefined,
        className: undefined,
        richText: caption
    });
    return Cite || caption ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
        className: `${(leadMedia_module_default()).caption} ${(responsiveImageModule_module_default()).caption}`,
        children: [
            Cap,
            credit && caption ? " | " : "",
            Cite
        ]
    }) : null;
};


// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(7563);
;// CONCATENATED MODULE: ./src/utils/pilbox.ts

const IMAGE_FILE_EXTENSIONS = [
    ".jpg",
    ".jpeg",
    ".gif",
    ".png"
];
const stripTrailingSlash = (input)=>input.endsWith("/") ? input.slice(0, -1) : input;
const genPilboxURL = (pilboxHost = "", imageUrl, options)=>{
    // default quality of 90 as pilbox default is 50
    // eslint-disable-next-line no-param-reassign
    options.q = options.q || 90;
    const currentExtension = IMAGE_FILE_EXTENSIONS.find((extension)=>imageUrl.toLowerCase().includes(extension)) || "";
    const queryParams = {
        url: imageUrl,
        ...Object.keys(options).reduce((result, key)=>{
            if (options[key] === undefined) {
                return result;
            }
            return {
                ...result,
                [key]: options[key]
            };
        }, {})
    };
    return `${stripTrailingSlash(pilboxHost)}/image${currentExtension}?${(0,query_string.stringify)(queryParams)}`;
};


;// CONCATENATED MODULE: ./src/components/ResponsiveImage.tsx






const pilboxConfig = {
    filter: "antialias",
    mode: "scale",
    pos: "top-left",
    opt: 1,
    prog: 1,
    q: "keep"
};
/**
 * Generates the CDN URL of an image given its path and the CDN URL.
 */ const getCDNUrl = (path, media)=>{
    const url = !/^http/.test(path) ? `${media}/${path}` : path;
    return `${url.replace("//media", "/media")}`;
};
/**
 * Provides a responsive image using srcSet, aspect ratios and pillbox.
 * @example
 * <ResponsiveImage
 *     alt="FluffyKins"
 *     className="jumbotron"
 *     url="//media/image.jpg"
 *     mobileWidth={320}
 *     tabletWidth={200}
 *     laptopWidth={162}
 *     desktopWidth={180}
 *     bigScreenWidth={206}
 *     mobileHeight={320}
 *     tabletHeight={200}
 *     laptopHeight={162}
 *     desktopHeight={180}
 *     bigScreenHeight={206}
 *     round{false}
 * />
 */ const ResponsiveImage = (props)=>{
    const { publicRuntimeConfig: { pilboxHost , staticAssetHost  }  } = (0,config["default"])();
    const { url , mobileWidth , tabletWidth , laptopWidth , desktopWidth , bigScreenWidth , mobileHeight , tabletHeight , laptopHeight , desktopHeight , bigScreenHeight , className , altText , credit , creditLink , caption , mode , loading , extraProps  } = props;
    if (!url) {
        return null;
    }
    // Images should always have an alt text.
    const alt = altText || caption || credit || "";
    // always fall back to the next smaller size.
    const mobileW = mobileWidth;
    const tabletW = tabletWidth || mobileW;
    const laptopW = laptopWidth || tabletW;
    const desktopW = desktopWidth || laptopW;
    const bigScreenW = bigScreenWidth || desktopW;
    // always fall back to the next smaller size.
    const mobileH = mobileHeight;
    const tabletH = tabletHeight || mobileH;
    const laptopH = laptopHeight || tabletH;
    const desktopH = desktopHeight || laptopH;
    const bigScreenH = bigScreenHeight || desktopH;
    const cdnUrl = getCDNUrl(url, staticAssetHost);
    // Generate each breakpoints Pilbox URL.
    const xs = genPilboxURL(pilboxHost, cdnUrl, {
        ...pilboxConfig,
        mode,
        w: mobileW,
        h: mobileH
    });
    const sm = genPilboxURL(pilboxHost, cdnUrl, {
        ...pilboxConfig,
        mode,
        w: tabletW,
        h: tabletH
    });
    const md = genPilboxURL(pilboxHost, cdnUrl, {
        ...pilboxConfig,
        mode,
        w: laptopW,
        h: laptopH
    });
    const lg = genPilboxURL(pilboxHost, cdnUrl, {
        ...pilboxConfig,
        mode,
        w: desktopW,
        h: desktopH
    });
    const xl = genPilboxURL(pilboxHost, cdnUrl, {
        ...pilboxConfig,
        mode,
        w: bigScreenW,
        h: bigScreenH
    });
    // add some class names
    // eslint-disable-next-line react/destructuring-assignment
    const modifier = props.round ? `${(responsiveImageModule_module_default()).imageResponsive} ${(responsiveImageModule_module_default()).imageRound}` : (responsiveImageModule_module_default()).imageResponsive;
    const wrapperClass = [
        modifier,
        className
    ].join(" ");
    // Building up the srcSet as an object so we remove duplicate sizes/paths
    const srcSet = {};
    srcSet[`${mobileW}w`] = xs;
    srcSet[`${tabletW}w`] = srcSet[`${tabletW}w`] || sm;
    srcSet[`${laptopW}w`] = srcSet[`${laptopW}w`] || md;
    srcSet[`${desktopW}w`] = srcSet[`${desktopW}w`] || lg;
    srcSet[`${bigScreenW}w`] = srcSet[`${bigScreenW}w`] || xl;
    // Building up the sizes as an object so we remove duplicate sizes/breakpoints
    const sizes = {};
    sizes[`${mobileW}px`] = "(max-width: 567px)";
    sizes[`${tabletW}px`] = sizes[`${tabletW}px`] || "(min-width: 567px)";
    sizes[`${laptopW}px`] = sizes[`${laptopW}px`] || "(min-width: 1024px)";
    sizes[`${desktopW}px`] = sizes[`${desktopW}px`] || "(min-width: 1200px)";
    sizes[`${bigScreenW}px`] = sizes[`${bigScreenW}px`] || "(min-width: 1600px)";
    // Function for mapping over the SrcSet.
    const getSrcSet = (key)=>`${srcSet[key]} ${key}`;
    // loop over the srcset and join it all together `path size`
    const srcSetMap = Object.keys(srcSet).map(getSrcSet).join(",");
    // Function for mapping over the sizes.
    const getSize = (val, _i, self)=>val === self[self.length - 1] ? val : `${sizes[val]} ${val}`;
    // loop over the sizesMap and join it all together `breakpoint size`
    const sizesMap = Object.keys(sizes).map(getSize).join(",");
    const isEager = loading === "eager";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: alt,
                className: isEager ? wrapperClass : `${wrapperClass} lazy`,
                src: xl,
                srcSet: srcSetMap,
                loading: loading ?? "lazy",
                sizes: sizesMap,
                width: bigScreenW,
                height: bigScreenH,
                ...extraProps
            }),
            !!caption || !!credit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Caption, {
                caption,
                credit,
                creditLink
            }) : null
        ]
    });
};



/***/ }),

/***/ 3720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ RichTextModule; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const RichTextModule = (props)=>{
    const { className , richText  } = props;
    // eslint-disable-next-line react/no-danger
    return richText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className,
        dangerouslySetInnerHTML: {
            __html: richText
        }
    }) : null;
};



/***/ }),

/***/ 908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TrendingSearch": function() { return /* binding */ TrendingSearch; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1752);
/* harmony import */ var _themuse_design_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8340);
/* harmony import */ var _themuse_snowplow_js_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8580);
/* harmony import */ var _themuse_snowplow_js_client__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_themuse_snowplow_js_client__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var hooks_AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3863);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3135);
/* harmony import */ var _trendingSearch_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1211);
/* harmony import */ var _trendingSearch_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_trendingSearch_module_scss__WEBPACK_IMPORTED_MODULE_5__);


/* eslint-disable react/jsx-no-target-blank */ 






/**
 * Retrieves the details of a job category based on the provided key.
 */ const getCategoryDetails = (key)=>utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .jobCategoryItems.filter */ .Y0.filter((x)=>x.label === key).pop();
/**
 * Component for displaying the grouping of Stars.
 */ const Stars = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 63 47",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#1D2D5A",
                        d: "M11.771 1.978h-.092A11.742 11.742 0 0 1 .367 12.758v.02A11.745 11.745 0 0 1 11.73 24.515a11.747 11.747 0 0 1 11.747-11.748A11.745 11.745 0 0 1 11.77 1.978Z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#F69576",
                        d: "M23.635 20.9h-.105a13.372 13.372 0 0 1-12.882 12.275v.024a13.375 13.375 0 0 1 12.94 13.365 13.377 13.377 0 0 1 13.377-13.377 13.375 13.375 0 0 1-13.33-12.288Z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#1D2D5A",
                        d: "M44.19.457h-.145a18.475 18.475 0 0 1-17.799 16.96v.034a18.481 18.481 0 0 1 17.878 18.467 18.484 18.484 0 0 1 18.484-18.484A18.48 18.48 0 0 1 44.19.457Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h63v47H0z"
                    })
                })
            })
        ]
    });
/**
 * An object of snowplows impression event.
 */ const impressionTracking = {
    sp_impression_component: "insert",
    sp_impression_insert_type: "trending_searches",
    sp_impression_position: "in_article"
};
/**
 * Returns an object of snowplows click event.
 */ const getClickTracking = (linkText, position)=>({
        sp_click_component: "insert",
        sp_click_insert_type: "trending_searches",
        sp_click_position: position ?? "in_article",
        sp_click_link_text: linkText,
        sp_click_target_page_section: "search",
        sp_tile_entity_id: null,
        sp_tile_type: null
    });
/**
 * Functional component for rendering a trending anchor link.
 */ const TrendingAnchor = (props)=>{
    const { label , value , jobLocation , tracking , position , linkText  } = props;
    const { publicRuntimeConfig: { museHost  }  } = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
        className: (_trendingSearch_module_scss__WEBPACK_IMPORTED_MODULE_5___default().searchItem),
        href: `${museHost}/search/${jobLocation}keyword/${label}/category/${value}/`,
        onClick: ()=>(0,_themuse_snowplow_js_client__WEBPACK_IMPORTED_MODULE_6__.triggerSnowplowClickEvent)(tracking),
        target: "_blank",
        rel: "noopener",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_trendingSearch_module_scss__WEBPACK_IMPORTED_MODULE_5___default().searchNumber),
                children: `${position}.`
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_trendingSearch_module_scss__WEBPACK_IMPORTED_MODULE_5___default().searchText),
                children: linkText
            })
        ]
    }, value);
};
TrendingAnchor.displayName = "TrendingAnchor";
/**
 * Functional component for displaying trending searches module.
 * * The blocks are broken up so that numbering does not bounce from side to side.
 */ const TrendingSearch = ()=>{
    const { publicRuntimeConfig: { museHost  }  } = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])();
    const { article , user  } = (0,hooks_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .useAppState */ .mr)();
    const { careerTypes =[]  } = article;
    const { location: { dma  }  } = user;
    const jobLocation = dma ? `location/${(0,_themuse_design_system__WEBPACK_IMPORTED_MODULE_7__/* .slugify */ .lV)(dma)}/` : "";
    const careerTags = careerTypes.map((x)=>x.title);
    const activeCareer = Object.keys(utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .careerTypeMapping */ .I8).find((career)=>careerTags.includes(career)) || "Default";
    const heading = dma ? `Trending Searches in ${dma}` : "Trending Searches";
    const split = Math.round(utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .careerTypeMapping */ .I8[activeCareer].length / 2);
    const left = utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .careerTypeMapping */ .I8[activeCareer].slice(0, split);
    const right = utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .careerTypeMapping */ .I8[activeCareer].slice(split);
    const { 0: contentPosition , 1: setContentPosition  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("in_article");
    const impression = {
        ...impressionTracking,
        sp_impression_position: contentPosition
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!window.location.href.includes("/advice")) {
            setContentPosition("main");
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("aside", {
        className: (_trendingSearch_module_scss__WEBPACK_IMPORTED_MODULE_5___default().trendingSearch),
        "data-tracking-props": JSON.stringify(impression),
        "data-tracking-event-type": "impression",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: heading
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Stars, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_trendingSearch_module_scss__WEBPACK_IMPORTED_MODULE_5___default().row),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_trendingSearch_module_scss__WEBPACK_IMPORTED_MODULE_5___default().column),
                        children: left.map((career, index)=>{
                            const position = index + 1;
                            const { label ="" , value =""  } = getCategoryDetails(career) ?? {};
                            const linkText = `${label} Jobs`;
                            const tracking = getClickTracking(linkText, contentPosition);
                            // early return if getCategoryDetails failed to get a category
                            if (!label || !value) return null;
                            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(TrendingAnchor, {
                                label,
                                value,
                                jobLocation,
                                tracking,
                                position,
                                linkText,
                                key: value
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_trendingSearch_module_scss__WEBPACK_IMPORTED_MODULE_5___default().column),
                        children: right.map((career, index)=>{
                            const position = index + split + 1;
                            const { label ="" , value =""  } = getCategoryDetails(career) ?? {};
                            const linkText = `${label} Jobs`;
                            const tracking = getClickTracking(linkText, contentPosition);
                            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(TrendingAnchor, {
                                label,
                                value,
                                jobLocation,
                                tracking,
                                position,
                                linkText,
                                key: value
                            });
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: (_trendingSearch_module_scss__WEBPACK_IMPORTED_MODULE_5___default().searchAllJobs),
                href: `${museHost}/search/`,
                onClick: ()=>(0,_themuse_snowplow_js_client__WEBPACK_IMPORTED_MODULE_6__.triggerSnowplowClickEvent)(getClickTracking("SEARCH ALL JOBS", contentPosition)),
                target: "_blank",
                rel: "noopener",
                children: "SEARCH ALL JOBS"
            })
        ]
    });
};
TrendingSearch.displayName = "TrendingSearch";


/***/ }),

/***/ 7915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IR": function() { return /* binding */ jobAlertCategories; },
/* harmony export */   "Kk": function() { return /* binding */ trackingData; },
/* harmony export */   "YW": function() { return /* binding */ locationAltValues; }
/* harmony export */ });
const jobAlertCategories = [
    {
        label: "Media, PR, and Communications",
        value: "media_pr_communications"
    },
    {
        label: "Sales",
        value: "sales"
    },
    {
        label: "Product Management",
        value: "product_management"
    },
    {
        label: "Design and UX",
        value: "design_ux"
    },
    {
        label: "Software Engineering",
        value: "software_engineering"
    },
    {
        label: "Human Resources and Recruitment",
        value: "human_resources_recruitment"
    },
    {
        label: "Accounting and Finance",
        value: "accounting_finance"
    },
    {
        label: "Project Management",
        value: "project_management"
    },
    {
        label: "Customer Service",
        value: "customer_service"
    },
    {
        label: "Data and Analytics",
        value: "data_analytics"
    },
    {
        label: "Account Management",
        value: "account_management"
    },
    {
        label: "Administration and Office",
        value: "administration_office"
    },
    {
        label: "Advertising and Marketing",
        value: "advertising_marketing"
    },
    {
        label: "Animal Care",
        value: "animal_care"
    },
    {
        label: "Arts",
        value: "arts"
    },
    {
        label: "Business Operations",
        value: "business_operations"
    },
    {
        label: "Cleaning and Facilities",
        value: "cleaning_facilities"
    },
    {
        label: "Computer and IT",
        value: "computer_it"
    },
    {
        label: "Construction",
        value: "construction"
    },
    {
        label: "Education",
        value: "education"
    },
    {
        label: "Energy Generation and Mining",
        value: "energy_generation_mining"
    },
    {
        label: "Entertainment and Travel Services",
        value: "entertainment_travel"
    },
    {
        label: "Farming and Outdoors",
        value: "farming_outdoors"
    },
    {
        label: "Food and Hospitality Services",
        value: "food_hospitality"
    },
    {
        label: "Healthcare",
        value: "healthcare"
    },
    {
        label: "Installation, Maintenance, and Repairs",
        value: "installation_maintenance_repairs"
    },
    {
        label: "Legal Services",
        value: "legal"
    },
    {
        label: "Management",
        value: "management"
    },
    {
        label: "Manufacturing and Warehouse",
        value: "manufacturing_warehouse"
    },
    {
        label: "Personal Care and Services",
        value: "personal_care"
    },
    {
        label: "Protective Services",
        value: "protective_services"
    },
    {
        label: "Real Estate",
        value: "real_estate"
    },
    {
        label: "Retail",
        value: "retail"
    },
    {
        label: "Science and Engineering",
        value: "science_engineering"
    },
    {
        label: "Social Services",
        value: "social_services"
    },
    {
        label: "Sports, Fitness, and Recreation",
        value: "sports_fitness_recreation"
    },
    {
        label: "Transportation and Logistics",
        value: "transportation_logistics"
    },
    {
        label: "Writing and Editing",
        value: "writing_editing"
    }, 
];
const locationAltValues = {
    "Remote / Flexible": "Flexible / Remote"
};
const trackingData = {
    newsletter: {
        impression: JSON.stringify({
            sp_impression_component: "insert",
            sp_impression_modal_type: "newsletter",
            sp_impression_position: "right_rail",
            sp_page_company_id: null,
            sp_page_is_external: false,
            sp_page_section: "advice",
            sp_page_tab: null,
            sp_page_type: "content"
        }),
        success: {
            sp_modal_type: "newsletter",
            sp_modal_error_type: null,
            sp_modal_action_type: "submit",
            sp_modal_newsletter_opt_in: null,
            sp_modal_screen_order: null,
            sp_modal_screen_name: null
        }
    },
    signup: {
        impression: JSON.stringify({
            sp_impression_component: "insert",
            sp_impression_modal_type: "job_alert",
            sp_impression_position: "right_rail",
            sp_page_company_id: null,
            sp_page_is_external: false,
            sp_page_section: "advice",
            sp_page_tab: null,
            sp_page_type: "entity"
        }),
        notice: JSON.stringify({
            sp_impression_component: "insert",
            sp_impression_modal_type: "newsletter_success",
            sp_impression_position: "right_rail",
            sp_page_company_id: null,
            sp_page_is_external: false,
            sp_page_section: "advice",
            sp_page_tab: null,
            sp_page_type: "entity"
        }),
        success: {
            sp_modal_type: "job_alert",
            sp_modal_error_type: null,
            sp_modal_action_type: "submit",
            sp_modal_newsletter_opt_in: null,
            sp_modal_job_alert_opt_in: true,
            sp_modal_screen_order: null,
            sp_modal_screen_name: null
        }
    },
    success: {
        impression: JSON.stringify({
            sp_impression_component: "insert",
            sp_impression_modal_type: "jobalert_success",
            sp_impression_position: "right_rail",
            sp_page_company_id: null,
            sp_page_is_external: false,
            sp_page_section: "advice",
            sp_page_tab: null,
            sp_page_type: "entity"
        })
    }
};


/***/ }),

/***/ 65:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ FeatureFlagsProvider; },
  "n": function() { return /* binding */ useFeatureFlagsState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(2918);
;// CONCATENATED MODULE: ./src/utils/featureFlags.ts


/**
 * Take a name and determine if the feature flag is activated
 * based on environment variable and query params.
 */ const isFeatureFlagActive = (name, query, config)=>{
    if (name in query) {
        return isTruthy(query[name]);
    }
    if (config?.[name] !== undefined) {
        return config?.[name] === true || config?.[name] === "true";
    }
    return false;
};
/**
 * Returns a list of all existing flags in the config.
 */ const getFeatureFlags = ()=>{
    const { publicRuntimeConfig  } = (0,config["default"])();
    return Object.keys(publicRuntimeConfig).reduce((prev, curr)=>{
        if (/^FEATURE_FLAG/.test(curr)) {
            prev.push(curr);
        }
        return prev;
    }, []);
};
/**
 * Returns all active flags in the config and/or query params.
 */ const getActiveFeatureFlags = (context)=>{
    const { query  } = context;
    const { publicRuntimeConfig  } = getConfig();
    const featureFlagsInQuery = getFeatureFlags().reduce((featureFlags, featureFlag)=>({
            ...featureFlags,
            [featureFlag]: isFeatureFlagActive(featureFlag, query, publicRuntimeConfig)
        }), {});
    return featureFlagsInQuery;
};


;// CONCATENATED MODULE: ./src/hooks/FeatureFlagsContext.tsx



const defaultFeatureFlagsState = Object.keys(getFeatureFlags()).reduce((featureFlags, featureFlag)=>({
        ...featureFlags,
        [featureFlag]: false
    }), {});
const FeatureFlagsContext = /*#__PURE__*/ react.createContext(defaultFeatureFlagsState);
const FeatureFlagsProvider = (props)=>{
    const { featureFlags , children  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext.Provider, {
        value: featureFlags,
        children: children
    });
};
const useFeatureFlagsState = ()=>{
    const context = react.useContext(FeatureFlagsContext);
    if (context === undefined) {
        throw new Error("useFeatureFlagsState must be used within the FeatureFlagsProvider");
    }
    return context;
};
FeatureFlagsProvider.displayName = "FeatureFlagsProvider";
useFeatureFlagsState.displayName = "useFeatureFlagsState";



/***/ }),

/***/ 6071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; },
  "formatCompanySuggestions": function() { return /* binding */ formatCompanySuggestions; },
  "updateInput": function() { return /* binding */ updateInput; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/hooks/useSessionStorage/useSessionStorage.tsx + 1 modules
var useSessionStorage = __webpack_require__(5310);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/Search.tsx
var Search = __webpack_require__(4940);
// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var build = __webpack_require__(8580);
// EXTERNAL MODULE: ./node_modules/@themuse/experiment-client/build/index.js
var experiment_client_build = __webpack_require__(6680);
// EXTERNAL MODULE: ./src/interfaces/context/appContextInterfaces.ts
var appContextInterfaces = __webpack_require__(4182);
// EXTERNAL MODULE: ./src/utils/tracking.tsx
var tracking = __webpack_require__(1771);
// EXTERNAL MODULE: ./src/utils/browser.ts
var browser = __webpack_require__(7228);
// EXTERNAL MODULE: ./src/utils/logging.ts
var logging = __webpack_require__(4453);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(2918);
// EXTERNAL MODULE: ./src/utils/api.ts + 4 modules
var api = __webpack_require__(8388);
// EXTERNAL MODULE: ./src/hooks/AppContext.tsx + 4 modules
var AppContext = __webpack_require__(3863);
// EXTERNAL MODULE: ./src/hooks/FeatureFlagsContext.tsx + 1 modules
var FeatureFlagsContext = __webpack_require__(65);
// EXTERNAL MODULE: ./src/components/AppPageLayout.tsx
var AppPageLayout = __webpack_require__(7155);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/styles/common.module.scss
var common_module = __webpack_require__(30);
var common_module_default = /*#__PURE__*/__webpack_require__.n(common_module);
// EXTERNAL MODULE: ./src/components/articleHeader.module.scss
var articleHeader_module = __webpack_require__(3144);
var articleHeader_module_default = /*#__PURE__*/__webpack_require__.n(articleHeader_module);
;// CONCATENATED MODULE: ./src/components/ArticleHeader.tsx




const ArticleBreadcrumbLinks = (props)=>{
    const { crumbs , articleTitle  } = props;
    const linkStyle = `${(articleHeader_module_default()).breadCrumbLink} ${(common_module_default()).callToAction}`;
    const cleanCrumbs = crumbs.filter((x)=>x.title && x.title !== articleTitle);
    const crumbsLength = cleanCrumbs.length - 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: cleanCrumbs.map((x, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: `/${x.uri}`,
                        className: linkStyle,
                        children: x.title
                    }),
                    i < crumbsLength ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: linkStyle,
                        children: " / "
                    }) : null
                ]
            }, x.title))
    });
};
const ArticleHeader = ({ articleTitle , breadcrumbs  })=>{
    const crumbs = breadcrumbs.filter((x)=>x.title && x.uri && x.title !== articleTitle).map((x)=>/^advice$/i.test(x.uri) ? {
            title: "Advice",
            uri: "advice"
        } : x);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: (articleHeader_module_default()).articleHeader,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (articleHeader_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleBreadcrumbLinks, {
                    crumbs: crumbs,
                    articleTitle: articleTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (articleHeader_module_default()).title,
                    children: articleTitle
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/SVGIconPinterestBox.tsx

/* eslint-disable max-len */ 
const SVGIconPinterestBox = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 243 243",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "121.5",
                cy: "121.5",
                r: "121.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.5,0C54.4,0,0,54.4,0,121.5C0,173,32,217,77.2,234.7c-1.1-9.6-2-24.4,0.4-34.9 c2.2-9.5,14.2-60.4,14.2-60.4s-3.6-7.3-3.6-18c0-16.9,9.8-29.5,22-29.5c10.4,0,15.4,7.8,15.4,17.1c0,10.4-6.6,26-10.1,40.5 c-2.9,12.1,6.1,22,18,22c21.6,0,38.2-22.8,38.2-55.6c0-29.1-20.9-49.4-50.8-49.4c-34.6,0-54.9,25.9-54.9,52.7 c0,10.4,4,21.6,9,27.7c1,1.2,1.1,2.3,0.8,3.5c-0.9,3.8-3,12.1-3.4,13.8c-0.5,2.2-1.8,2.7-4.1,1.6c-15.2-7.1-24.7-29.2-24.7-47.1 c0-38.3,27.8-73.5,80.3-73.5c42.1,0,74.9,30,74.9,70.2c0,41.9-26.4,75.6-63,75.6c-12.3,0-23.9-6.4-27.8-14c0,0-6.1,23.2-7.6,28.9 c-2.7,10.6-10.1,23.8-15.1,31.9c11.4,3.5,23.4,5.4,36,5.4c67.1,0,121.5-54.4,121.5-121.5C243,54.4,188.6,0,121.5,0z"
            })
        ]
    });

// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(3135);
// EXTERNAL MODULE: ./src/components/RichTextModule.tsx
var RichTextModule = __webpack_require__(3720);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(7066);
;// CONCATENATED MODULE: ./src/utils/jwPlayer.ts
/* eslint-disable no-undef */ 




const JWPLAYER_API_URL = "//cdn.jwplayer.com/v2/media/";
const TRACKED_PLAYBACK_MILESTONES = [
    25,
    50,
    75,
    100
];
const getJWPlayerVideoInfo = async (mediaID)=>{
    try {
        const response = await axios/* default.get */.Z.get(`${JWPLAYER_API_URL}${mediaID}`);
        return response.data;
    } catch (error) {
        console.error("Unable to fetch playlist info from JWPlayer API.", JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
    }
    return null;
};
const initJWPlayerVideo = ({ container , videoInfo , autostart , mute , generateSEOMetadata  })=>{
    const { playlist  } = videoInfo;
    if (typeof jwplayer !== "undefined") {
        return jwplayer(container.current).setup({
            playlist,
            autostart,
            mute,
            generateSEOMetadata
        });
    }
    return null;
};
const initJWPlayerTracking = (props)=>{
    const { playerInstance , videoInfo , position , element  } = props;
    Object.assign(window, {
        playerInstance
    });
    const config = playerInstance.getConfig();
    // only the first play is played, everything else is resumed.
    let started = false;
    let firstView = false;
    const getEventProps = ()=>{
        const result = {
            jw_video_source: position || null,
            jw_video_id: null,
            jw_video_name: videoInfo.title || null,
            jw_video_provider_key: config.id.replace("jwplayer-", "") || null,
            jw_video_provider_name: "jwplayer",
            jw_video_description: videoInfo.description || null,
            jw_video_autoplay: config.autostart || null,
            jw_video_muted: !!playerInstance.getMute(),
            jw_video_position: jwplayer().getPosition()
        };
        return result;
    };
    playerInstance.on("viewable", ()=>{
        // The viewable event is bugged, so we add a getViewable check
        if (!firstView && playerInstance.getViewable()) {
            (0,build.triggerSnowplowImpressionEvent)(element);
            firstView = true;
        }
    });
    playerInstance.on("play", ()=>{
        const eventName = started ? "jwPlayerResumed" : "jwPlayerPlayed";
        (0,tracking/* pushDataLayerEvent */.Jt)(eventName, getEventProps());
        started = true;
        (0,build.triggerSnowplowVideoEvent)("play", element);
    });
    playerInstance.on("pause", ()=>(0,tracking/* pushDataLayerEvent */.Jt)("jwPlayedPaused", getEventProps()));
    playerInstance.on("mute", (event)=>{
        if (event.mute) {
            (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerMuted", getEventProps());
        } else {
            (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerUnmuted", getEventProps());
        }
    });
    playerInstance.on("fullscreen", ()=>{
        const fullscreen = playerInstance.getFullscreen();
        const dataLayerProps = {
            ...getEventProps(),
            jw_video_fullscreen: fullscreen,
            interaction_type: fullscreen ? "enter fullscreen" : "exit fullscreen"
        };
        (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerInteraction", dataLayerProps);
    });
    playerInstance.on("autostartNotAllowed", ()=>(0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerAutostartNotAllowed", getEventProps()));
    playerInstance.on("seek", (event)=>{
        const dataLayerProps = {
            jw_video_seek_begin: event.position,
            jw_video_seek_end: event.offset,
            ...getEventProps(),
            interaction_type: event.position > event.offset ? "rewind" : "forward"
        };
        (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerInteraction", dataLayerProps);
    });
    playerInstance.on("time", (event)=>{
        const instance = playerInstance;
        const videoPercentComplete = event.position / event.duration * 100;
        TRACKED_PLAYBACK_MILESTONES.forEach((milestone)=>{
            const latestSeen = instance.latestPercentComplete || 0;
            if (videoPercentComplete >= milestone && milestone >= latestSeen) {
                (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerPlaybackMilestoneReached", {
                    video_percent_complete: milestone,
                    ...getEventProps()
                });
            }
        });
        instance.latestPercentComplete = videoPercentComplete;
    });
};

;// CONCATENATED MODULE: ./src/components/JWVideoModule.tsx




const JWVideoModule = ({ jwVideo , richText , heading , autostart =false , position ="post_individual_body"  })=>{
    const jwPlayerContainer = (0,react.useRef)(null);
    const jwPlayerWrapper = (0,react.useRef)(null);
    const { 0: videoInfo , 1: setVideoInfo  } = (0,react.useState)(null);
    const { 0: playerInstance , 1: setPlayerInstance  } = (0,react.useState)(null);
    const { 0: trackingProps , 1: setTrackingProps  } = (0,react.useState)(null);
    // Get the video info, then init the player instance.
    (0,react.useEffect)(()=>{
        getJWPlayerVideoInfo(jwVideo).then((video)=>{
            setVideoInfo(video);
            const instance = initJWPlayerVideo({
                videoInfo: video,
                autostart,
                container: jwPlayerContainer,
                mute: !!autostart
            });
            setPlayerInstance(instance);
        }).catch((error)=>{
            console.error("Error occurred while fetching video info:", error);
            setVideoInfo(null);
            setPlayerInstance(null);
        });
    }, [
        jwVideo,
        autostart
    ]);
    // Init tracking props if the player was successfully instantiated.
    (0,react.useEffect)(()=>{
        if (playerInstance) {
            setTrackingProps({
                "data-tracking-props": JSON.stringify({
                    sp_impression_component: "insert",
                    sp_impression_insert_type: "media",
                    sp_impression_position: "in_article",
                    sp_media_type: "video",
                    sp_media_name: videoInfo?.title ?? null,
                    sp_media_provider_key: jwVideo ?? null,
                    sp_media_provider_name: "jwplayer"
                })
            });
            initJWPlayerTracking({
                playerInstance,
                videoInfo,
                position,
                element: jwPlayerWrapper?.current
            });
        }
    }, [
        videoInfo,
        playerInstance,
        jwVideo,
        position
    ]);
    if (!jwVideo) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jwplayerModule",
        ...trackingProps,
        ref: jwPlayerWrapper,
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: `jwplayer-${jwVideo}`,
                className: "jwplayer-container",
                ref: jwPlayerContainer
            }),
            richText && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule/* RichTextModule */.n, {
                type: "richTextBlock",
                richText: richText
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/ResponsiveImage.tsx + 2 modules
var ResponsiveImage = __webpack_require__(887);
;// CONCATENATED MODULE: ./src/components/EmbedModule.tsx




const stripWhiteSpace = (str)=>str.replace(/\n/g, "");
const stripEnclosingDivs = (str)=>{
    let newstr = stripWhiteSpace(str);
    [, newstr] = newstr.match(/(?:<div>)(.*)(?=<\/div>)/m);
    return newstr;
};
const getEmbedClassname = (providerName)=>{
    const EmbedClassNameMap = {
        Facebook: "fb-embed-container",
        Twitter: "twitter-embed-container",
        YouTube: "ytplayer-embed-container",
        Instagram: "instagram-embed-container"
    };
    return Object.prototype.hasOwnProperty.call(EmbedClassNameMap, providerName) ? EmbedClassNameMap[providerName] : "other-embed-container";
};
const renderEmbed = (embed, template)=>{
    let oskarView;
    let oskarProps;
    if (embed.type && embed.type === "video") {
        let mediaID;
        let mediaProviderKey;
        if (embed.providerName === "YouTube") {
            mediaID = embed.url;
            mediaProviderKey = embed.url.split("=")[1];
        }
        const eventProps = {
            sp_impression_component: "insert",
            sp_impression_insert_type: "media",
            sp_impression_position: template === "article" ? "in_article" : null,
            sp_media_type: "video",
            sp_media_id: mediaID,
            sp_media_name: embed.title || null,
            sp_media_provider_key: mediaProviderKey || null,
            sp_media_provider_name: embed.providerName || null
        };
        const trackingProps = {
            viewEvent: "videoViewed",
            eventProps
        };
        const dataProps = (0,tracking/* getTrackingPropsAsDataAttrs */.hf)(trackingProps);
        ({ oskarView , oskarProps  } = dataProps);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: getEmbedClassname(embed.providerName),
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: stripEnclosingDivs(embed.code)
        },
        "data-video-view": oskarView,
        "data-oskar-props": oskarProps
    });
};
const EmbedModule = ({ heading , embed , richText , template  })=>{
    const { embed: embedContent  } = embed;
    if (!embedContent) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "article-body__content-module__embed",
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: heading
            }),
            renderEmbed(embedContent, template),
            richText && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule/* RichTextModule */.n, {
                className: "article-body__content-module__embed__rich-text",
                type: "richTextBlock",
                richText: richText
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/leadMedia.module.scss
var leadMedia_module = __webpack_require__(1111);
var leadMedia_module_default = /*#__PURE__*/__webpack_require__.n(leadMedia_module);
;// CONCATENATED MODULE: ./src/components/LeadMediaModule.tsx









const getPinUrl = (href, media, description)=>{
    const page = encodeURIComponent(href);
    const image = encodeURIComponent(media);
    const alt = encodeURIComponent(description);
    return `https://www.pinterest.com/pin/create/button/?url=${page}&media=${image}&description=${alt}`;
};
const Pinterest = (alt, url, href)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (leadMedia_module_default()).imagePin,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: getPinUrl(href, url, alt),
                rel: "nofollow noreferrer",
                target: "_blank",
                className: `${(leadMedia_module_default()).button} ${(leadMedia_module_default()).socialIcon} ${(leadMedia_module_default()).pinterest}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SVGIconPinterestBox, {})
            })
        })
    });
const RenderLeadImage = (props)=>{
    const { height =100 , width =100 , url , altText , credit , creditLink , caption  } = props;
    const aspect = height / width;
    const mobileWidth = constants/* LEAD_MEDIA_SMALL_WIDTH */.pB;
    const tabletWidth = constants/* LEAD_MEDIA_LARGE_WIDTH */.Zh;
    const mobileHeight = Math.ceil(mobileWidth * aspect);
    const tabletHeight = Math.ceil(tabletWidth * aspect);
    const extraProps = {
        fetchpriority: "high"
    };
    const leadImageProps = {
        altText,
        caption,
        className: (leadMedia_module_default()).imageResponsive,
        // The following linter issue is a bug in eslint
        // eslint-disable-next-line no-undef
        loading: "eager",
        credit,
        creditLink,
        mobileHeight,
        mobileWidth,
        tabletWidth,
        tabletHeight,
        url,
        extraProps
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t3, {
        ...leadImageProps
    });
};
const RenderEmbedVideo = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(EmbedModule, {
        type: "embedBlock",
        embed: props,
        template: "leadMedia"
    });
const RenderJWVideo = (props)=>{
    const { jwVideo  } = props;
    return jwVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(JWVideoModule, {
        type: "jwVideoBlock",
        jwVideo: jwVideo,
        autostart: true,
        position: "post_individual_header"
    });
};
const LeadMediaModule = (props)=>{
    const { pageMetaData  } = (0,AppContext/* useAppState */.mr)();
    const { href  } = pageMetaData;
    const { altText , showPinterest , type , url  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: (leadMedia_module_default()).leadMedia,
        children: [
            type === "image" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderLeadImage, {
                ...props
            }),
            type === "embedVideo" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderEmbedVideo, {
                ...props
            }),
            type === "jwVideo" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderJWVideo, {
                ...props
            }),
            showPinterest && Pinterest(altText, url, href)
        ]
    });
};

// EXTERNAL MODULE: ./src/components/articleSocial.module.scss
var articleSocial_module = __webpack_require__(9817);
var articleSocial_module_default = /*#__PURE__*/__webpack_require__.n(articleSocial_module);
;// CONCATENATED MODULE: ./src/components/ArticleSocial.tsx

/* eslint-disable max-len */ 


const { publicRuntimeConfig: { museHost  }  } = (0,config["default"])();
const getFaceBookUrl = (articleUri)=>{
    const base = "https://www.facebook.com/sharer/sharer.php?u=";
    const article = encodeURIComponent(`${museHost}/${articleUri}`);
    return `${base}${article}`;
};
const getTwitterUrl = (articleUri, title, twitterHandle)=>{
    const base = "https://twitter.com/intent/tweet?text=";
    const pageUrl = encodeURIComponent(`${museHost}/${articleUri}`);
    const signature = twitterHandle === "themuse" ? "TheMuse" : `%20%40TheMuse%20%40${twitterHandle}`;
    const pageTitle = encodeURIComponent(title);
    return `${base}${pageTitle}&url=${pageUrl}&via=${signature}`;
};
const getLinkedInUrl = (articleUri)=>{
    const base = "https://www.linkedin.com/shareArticle?url=";
    const pageUrl = encodeURIComponent(`${museHost}/${articleUri}`);
    return `${base}${pageUrl}`;
};
const getEmailUrl = (articleUri, title)=>{
    const subject = `mailto:?Subject=${title}`;
    const body = "&body=Just read this awesome article I thought I would share with you! Check it out here: ";
    const url = `${subject}${body}$${museHost}/${articleUri}`;
    return url;
};
const facebookIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-hidden": "false",
        role: "img",
        "aria-labelledby": "facebook-social",
        "aria-label": "Share on Facebook",
        height: "1em",
        width: "1em",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: "facebook-social",
                children: "Facebook"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFF",
                d: "M9 8H6v4h3v12h5V12h3.642L18 8h-4V6.333C14 5.378 14.192 5 15.115 5H18V0h-3.808C10.596 0 9 1.583 9 4.615V8z"
            })
        ]
    });
const linkedinIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-hidden": "false",
        role: "img",
        "aria-labelledby": "linkedin-social",
        "aria-label": "Share on LinkedIn",
        height: "1em",
        width: "1em",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: "linkedin-social",
                children: "LinkedIn"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFF",
                d: "M4.98 3.5C4.98 4.881 3.87 6 2.5 6S.02 4.881.02 3.5C.02 2.12 1.13 1 2.5 1s2.48 1.12 2.48 2.5zM5 8H0v16h5V8zm7.982 0H8.014v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0V24H24V13.869c0-7.88-8.922-7.593-11.018-3.714V8z"
            })
        ]
    });
const twitterIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-hidden": "false",
        role: "img",
        "aria-labelledby": "twitter-social",
        "aria-label": "Share on Twitter",
        height: "1em",
        width: "1em",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: "twitter-social",
                children: "Twitter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFF",
                d: "M24 4.557a9.83 9.83 0 01-2.828.775 4.932 4.932 0 002.165-2.724 9.864 9.864 0 01-3.127 1.195 4.916 4.916 0 00-3.594-1.555c-3.179 0-5.515 2.966-4.797 6.045A13.978 13.978 0 011.671 3.149a4.93 4.93 0 001.523 6.574 4.903 4.903 0 01-2.229-.616c-.054 2.281 1.581 4.415 3.949 4.89a4.935 4.935 0 01-2.224.084 4.928 4.928 0 004.6 3.419A9.9 9.9 0 010 19.54a13.94 13.94 0 007.548 2.212c9.142 0 14.307-7.721 13.995-14.646A10.025 10.025 0 0024 4.557z"
            })
        ]
    });
const emailIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-hidden": "false",
        role: "img",
        "aria-labelledby": "email-social",
        "aria-label": "Share via Email",
        height: "1em",
        width: "1em",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: "email-social",
                children: "Email"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFF",
                d: "M29.728 26.848v-13.696q-0.576 0.64-1.248 1.152-4.768 3.68-7.616 6.048-0.896 0.768-1.472 1.184t-1.536 0.896-1.824 0.416h-0.064q-0.832 0-1.824-0.416t-1.536-0.896-1.472-1.184q-2.816-2.368-7.616-6.048-0.672-0.512-1.248-1.152v13.696q0 0.224 0.192 0.416t0.384 0.16h26.304q0.224 0 0.384-0.16t0.192-0.416zM29.728 8.096v-0.448t-0.032-0.224-0.032-0.224-0.096-0.16-0.16-0.128-0.256-0.064h-26.304q-0.224 0-0.384 0.192t-0.192 0.384q0 3.008 2.656 5.088 3.424 2.688 7.136 5.632 0.128 0.096 0.64 0.544t0.8 0.672 0.8 0.544 0.896 0.512 0.768 0.16h0.064q0.352 0 0.768-0.16t0.896-0.512 0.8-0.544 0.8-0.672 0.64-0.544q3.712-2.944 7.168-5.632 0.96-0.768 1.792-2.080t0.832-2.336zM32 7.424v19.424q0 1.184-0.832 2.016t-2.016 0.864h-26.304q-1.152 0-2.016-0.864t-0.832-2.016v-19.424q0-1.184 0.832-2.016t2.016-0.832h26.304q1.184 0 2.016 0.832t0.832 2.016z"
            })
        ]
    });
/**
 * Generates an anchor wrapped around the social icon.
 */ const getIcon = (props)=>{
    const { url , type  } = props;
    const socialIcons = {
        facebook: facebookIcon,
        twitter: twitterIcon,
        linkedin: linkedinIcon,
        email: emailIcon
    };
    const Icon = socialIcons[type];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: `${(articleSocial_module_default()).icon} ${(articleSocial_module_default())[type]}`,
        "aria-label": type,
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
    });
};
/**
 * Generates the Social Sidebar Module.  This includes the Author Byline and the 4 social icons.
 */ const ArticleSocial = (props)=>{
    const { articleUri , title , twitterHandle , writerName , writerSlug , dateUpdated  } = props;
    const handle = twitterHandle ? twitterHandle.replace("@", "") : "themuse";
    const emailUrl = getEmailUrl(articleUri, title);
    const faceBookUrl = getFaceBookUrl(articleUri);
    const twitterUrl = getTwitterUrl(articleUri, title, handle);
    const linkedInUrl = getLinkedInUrl(articleUri);
    const writerUri = `/author/${writerSlug}`;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        id: "social-marker",
        className: (articleSocial_module_default()).social,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (articleSocial_module_default()).articleMetadata,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (articleSocial_module_default()).dataGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (articleSocial_module_default()).metadataField,
                                children: "by"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (articleSocial_module_default()).metadataData,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: writerUri,
                                    children: writerName
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (articleSocial_module_default()).dataGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (articleSocial_module_default()).metadataField,
                                children: "Updated"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (articleSocial_module_default()).metadataData,
                                children: dateUpdated
                            })
                        ]
                    })
                ]
            }),
            getIcon({
                ...{
                    url: faceBookUrl,
                    type: "facebook"
                }
            }),
            getIcon({
                ...{
                    url: twitterUrl,
                    type: "twitter"
                }
            }),
            getIcon({
                ...{
                    url: linkedInUrl,
                    type: "linkedin"
                }
            }),
            getIcon({
                ...{
                    url: emailUrl,
                    type: "email"
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/articleContainer.module.scss
var articleContainer_module = __webpack_require__(4847);
var articleContainer_module_default = /*#__PURE__*/__webpack_require__.n(articleContainer_module);
;// CONCATENATED MODULE: ./src/components/HtmlModule.tsx



const HtmlModule = (props)=>{
    const { html  } = props;
    // eslint-disable-next-line react/no-danger
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (articleContainer_module_default()).contentModule,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};

// EXTERNAL MODULE: ./src/components/blockQuote.module.scss
var blockQuote_module = __webpack_require__(8110);
var blockQuote_module_default = /*#__PURE__*/__webpack_require__.n(blockQuote_module);
;// CONCATENATED MODULE: ./src/components/BlockQuoteModule.tsx




const BlockQuoteModule = ({ blockquote , attribution  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (blockQuote_module_default()).pullQuote,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(blockQuote_module_default()).quoteMark}  ${(blockQuote_module_default()).open}`,
                children: "\u201C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule/* RichTextModule */.n, {
                    type: "richTextBlock",
                    richText: blockquote
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(blockQuote_module_default()).quoteMark}  ${(blockQuote_module_default()).close}`,
                children: "\u201D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                children: [
                    "\u2014\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule/* RichTextModule */.n, {
                        className: (blockQuote_module_default()).richText,
                        type: "richTextBlock",
                        richText: attribution
                    })
                ]
            })
        ]
    });

// EXTERNAL MODULE: ./src/components/divider.module.scss
var divider_module = __webpack_require__(5886);
var divider_module_default = /*#__PURE__*/__webpack_require__.n(divider_module);
;// CONCATENATED MODULE: ./src/components/DividerModule.tsx




const DividerModule = ({ heading , richText  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (divider_module_default()).divider,
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: heading
            }),
            richText && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule/* RichTextModule */.n, {
                richText,
                type: "richTextBlock"
            })
        ]
    });

;// CONCATENATED MODULE: ./src/components/TocModule.tsx


const TOCList = (props)=>{
    const { children , style  } = props;
    return style === "numeric" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: children
    });
};
/**
 * Return only the heading and the ID
 */ const createEntry = (module)=>{
    const { heading , id , inToc , type  } = module;
    return inToc ? {
        heading,
        id,
        inToc,
        type
    } : null;
};
/**
 * Checks to see if we have ny items are marked as being part of the TOC.
 */ const hasTocItems = (modules)=>!!modules && !!modules.filter((module)=>module && module.inToc && module.heading).length;
/**
 * Checks to see if we have a TOC generator.
 */ const hasTocGenerator = (modules)=>!!modules.filter((module)=>module && module.type === "tocGenerator").length;
/**
 * Checks for tocItems and generators.
 */ const hasToc = (modules)=>hasTocItems(modules) && hasTocGenerator(modules);
/**
 * Get all headings and IDs that are part of the TOC or an empty array.
 */ const getTOCEntries = (modules)=>!!modules && hasToc(modules) ? modules.filter((module)=>module && module.inToc && module.heading).map(createEntry) : [];
/**
 * Generate the list item either a paragraph for dividers or an LI.
 */ const ListItem = (props)=>{
    const { cleanHeading , id , index , type  } = props;
    return type === "divider" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: `#${id}`,
            children: cleanHeading
        })
    }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: `#${id}`,
            children: cleanHeading
        })
    }, index);
};
/**
 * Generates a Table of contents. With jump links to the content.
 */ const TocModule = (props)=>{
    const { style , entities  } = props;
    if (!entities) {
        return null;
    }
    const listItems = entities.map((item, index)=>{
        const { heading , id , inToc , type  } = item;
        // We strip out the markup for clean text in the bullet. We do not want nested anchors.
        const cleanHeading = inToc && heading && heading.replace(/<[^>]*>?/gm, "");
        return !!cleanHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
            cleanHeading,
            id,
            index,
            type
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TOCList, {
        style: style,
        children: listItems
    });
};

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(5824);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
// EXTERNAL MODULE: ./src/components/company.module.scss
var company_module = __webpack_require__(8900);
var company_module_default = /*#__PURE__*/__webpack_require__.n(company_module);
;// CONCATENATED MODULE: ./src/components/CompanyModule.tsx










const Description = ({ isArticle , description , replaceDescription , richText  })=>{
    const Extended = (0,react.useCallback)(()=>richText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule/* RichTextModule */.n, {
            type: "richTextBlock",
            className: "extended",
            richText: richText
        }) : null, [
        richText
    ]);
    const Static = (0,react.useCallback)(()=>description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule/* RichTextModule */.n, {
            type: "richTextBlock",
            className: "legacy",
            richText: description
        }) : null, [
        description
    ]);
    const Both = (0,react.useCallback)(()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Static, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Extended, {})
            ]
        }), [
        Extended,
        Static
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isArticle ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (company_module_default()).description,
            children: replaceDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Extended, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Both, {})
        })
    });
};
/**
 * Creates a company module within the page.
 * Passing an order number will render a listicle style with both a heading and description.
 * @example
 * <CompanyModule {...MOCK_COMPANY} />
 * <CompanyModule isArticle={true}{...MOCK_COMPANY} />
 */ const CompanyModule = (props)=>{
    const { isArticle , replaceDescription , richText , orderNum , company  } = props;
    // set sensible defaults for all of company props.
    const { shortName ="" , primaryImage ="" , secondaryImage ="" , tertiaryImage ="" , description ="" , title ="" , slug ="" , legacyId =0 , id =0  } = company ?? {};
    const aspect = 0.73896353167;
    const alt = {
        profile: `${title} company profile`,
        culture: `${title}  culture`,
        working: `Working at ${title}`
    };
    const impressionTrackingProps = {
        content_type: "module",
        company_name: title,
        company_short_name: slug,
        company_id: legacyId,
        company_craft_id: id,
        placement_position: orderNum,
        sp_content_is_tile: true,
        sp_tile_entity_id: (0,strings/* getId */.zv)(legacyId).toString(),
        sp_tile_order: orderNum,
        sp_tile_type: "round_up",
        sp_tile_company_id: legacyId.toString(),
        sp_impression_component: "tile",
        sp_impression_position: "in_article",
        sp_impression_tile_type: "round_up",
        sp_page_section: "advice",
        sp_page_type: "content"
    };
    const serializedImpressionTrackingProps = JSON.stringify(impressionTrackingProps);
    const clickTrackingProps = (0,react.useMemo)(()=>({
            sp_click_component: "button",
            sp_click_component_tile_type: "round_up",
            sp_click_insert_type: null,
            sp_click_position: "main",
            sp_click_search_id: null,
            sp_page_type: "content",
            sp_page_section: "advice",
            sp_page_company_id: legacyId.toString(),
            sp_page_tab: null,
            sp_is_external_page: false,
            sp_page_entity_id: id,
            sp_tile_entity_id: (0,strings/* getId */.zv)(legacyId).toString(),
            sp_tile_order: orderNum,
            sp_tile_type: "round_up",
            sp_tile_company_id: legacyId.toString()
        }), [
        id,
        legacyId,
        orderNum
    ]);
    const profileTrackingProps = {
        ...clickTrackingProps,
        sp_click_button_text: "view profile",
        sp_click_button_type: "profile",
        sp_click_component: "button",
        sp_click_target_page_section: "profile"
    };
    const { 0: jobsCount , 1: setJobsCount  } = (0,react.useState)();
    const getSearchTrackingProps = (0,react.useCallback)(()=>({
            ...clickTrackingProps,
            sp_click_button_text: jobsCount ? `Explore ${jobsCount} Open Jobs` : "Explore Jobs",
            sp_click_button_type: "job_search",
            sp_click_component: "button",
            sp_click_target_page_section: "search"
        }), [
        jobsCount,
        clickTrackingProps
    ]);
    const imageTrackingProps = {
        ...clickTrackingProps,
        sp_click_component: "tile",
        sp_tile_entity_id: (0,strings/* getId */.zv)(legacyId).toString(),
        sp_tile_order: orderNum,
        sp_tile_company_id: legacyId.toString(),
        sp_click_target_page_section: "profile"
    };
    const imageTrackingData = {
        "data-tracking-event-type": "click",
        "data-tracking-props": JSON.stringify(imageTrackingProps)
    };
    const mobilePrimary = 325;
    const tabletPrimary = 447;
    const mobileSecondary = 217;
    const sizesPrimary = {
        mobileWidth: mobilePrimary,
        mobileHeight: Math.ceil(mobilePrimary * aspect),
        tabletWidth: tabletPrimary,
        tabletHeight: Math.ceil(tabletPrimary * aspect)
    };
    const sizesSecondary = {
        mobileWidth: mobileSecondary,
        mobileHeight: Math.ceil(mobileSecondary * aspect)
    };
    const profileUrl = `/profiles/${shortName}`;
    const jobsUrl = `/hiring/company/${shortName}`;
    const getJobCount = (0,react.useCallback)(async ()=>{
        const { publicRuntimeConfig: { apiBase  }  } = (0,config["default"])();
        const url = `${apiBase}/job-search?company_short_name=${shortName}`;
        // eslint-disable-next-line no-return-await
        const jobCount = await axios/* default.get */.Z.get(url, {
            method: "GET",
            timeout: 5000,
            headers: {
                "content-type": "application/json;charset=UTF-8"
            }
        });
        setJobsCount(jobCount?.data?.count ?? 0);
    }, [
        shortName
    ]);
    const intersectionProps = {
        triggerOnce: true,
        rootMargin: "0px"
    };
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)(intersectionProps);
    (0,react.useEffect)(()=>{
        if (inView) {
            getJobCount();
        }
    }, [
        inView,
        getJobCount
    ]);
    // Early return if company is archived but not removed from an article/listicle.
    if (!id) return;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ref: ref,
        "data-oskar-click": "adviceCompanyModuleClicked",
        "data-oskar-view": "adviceCompanyModuleViewed",
        "data-oskar-props": serializedImpressionTrackingProps,
        "data-tracking-event-type": "impression",
        "data-tracking-props": serializedImpressionTrackingProps,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                    className: (company_module_default()).officeGrid,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (company_module_default()).primary,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: profileUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t3, {
                                    loading: "lazy",
                                    altText: alt.profile,
                                    url: primaryImage,
                                    ...sizesPrimary,
                                    extraProps: imageTrackingData
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (company_module_default()).secondary,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: profileUrl,
                                "data-tracking-event-type": "click",
                                "data-tracking-props": JSON.stringify(profileTrackingProps),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t3, {
                                    extraProps: imageTrackingData,
                                    loading: "lazy",
                                    altText: alt.culture,
                                    url: secondaryImage,
                                    ...sizesSecondary
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (company_module_default()).tertiary,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: profileUrl,
                                "data-tracking-event-type": "click",
                                "data-tracking-props": JSON.stringify(profileTrackingProps),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t3, {
                                    extraProps: imageTrackingData,
                                    loading: "lazy",
                                    altText: alt.working,
                                    url: tertiaryImage,
                                    ...sizesSecondary
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (company_module_default()).ctaButtons,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                            className: (company_module_default()).squareButton,
                            color: "light-blue",
                            href: profileUrl,
                            target: "_blank",
                            "data-tracking-event-type": "click",
                            "data-tracking-props": JSON.stringify(profileTrackingProps),
                            children: "View Profile"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                            className: (company_module_default()).squareButton,
                            color: "mint",
                            href: jobsUrl,
                            target: "_blank",
                            "data-tracking-event-type": "click",
                            "data-tracking-props": JSON.stringify(getSearchTrackingProps()),
                            children: jobsCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "Explore",
                                    " ",
                                    jobsCount,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "hidden visible--sm",
                                        children: "Open"
                                    }),
                                    " ",
                                    "Jobs"
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: "Explore Jobs"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                    isArticle,
                    replaceDescription,
                    description,
                    richText
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/CompanyLogoOutlined/CompanyLogoOutlined.tsx
var CompanyLogoOutlined = __webpack_require__(9139);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(4557);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Logos/MuseLogo.tsx
var MuseLogo = __webpack_require__(8615);
// EXTERNAL MODULE: ./src/components/sponsoredRecircWidget.module.scss
var sponsoredRecircWidget_module = __webpack_require__(7985);
var sponsoredRecircWidget_module_default = /*#__PURE__*/__webpack_require__.n(sponsoredRecircWidget_module);
;// CONCATENATED MODULE: ./src/components/SponsoredRecircWidget.tsx




const SponsoredRecircWidget = (props)=>{
    const { companyLogoUrl , companyName , companyProfileUrl , companyImageUrl  } = props;
    const clickTrackingProps = {
        "data-tracking-event-type": "click",
        "data-tracking-props": JSON.stringify({
            sp_click_component: "button",
            sp_click_button_type: "job_search",
            sp_click_insert_type: "sponsor_company_jobs",
            sp_click_button_text: "learn more",
            sp_click_position: "right_rail",
            sp_click_target_page_section: "profile"
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (sponsoredRecircWidget_module_default()).sponsoredRecircWidget,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (sponsoredRecircWidget_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (sponsoredRecircWidget_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogoOutlined/* default */.Z, {
                            className: (sponsoredRecircWidget_module_default()).logoPill,
                            altText: `${companyName} Logo`,
                            logoUrl: companyLogoUrl
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: `${companyName} Profile`,
                            loading: "lazy",
                            className: (sponsoredRecircWidget_module_default()).companyImage,
                            width: 300,
                            height: 200,
                            src: companyImageUrl
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (sponsoredRecircWidget_module_default()).mainContent,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                        className: (sponsoredRecircWidget_module_default()).title,
                        children: [
                            "Explore Jobs At",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (sponsoredRecircWidget_module_default()).companyName,
                                children: companyName
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (sponsoredRecircWidget_module_default()).footer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                        className: (sponsoredRecircWidget_module_default()).companyProfileCta,
                        color: "secondary-100",
                        href: companyProfileUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            ...clickTrackingProps,
                            children: "Learn More"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (sponsoredRecircWidget_module_default()).museLogo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MuseLogo/* default */.Z, {})
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/sponsorModule.module.scss
var sponsorModule_module = __webpack_require__(1719);
var sponsorModule_module_default = /*#__PURE__*/__webpack_require__.n(sponsorModule_module);
;// CONCATENATED MODULE: ./src/components/SponsorModule.tsx









/**
 * Return an object with all the possible sponsor placements and if they are valid.
 */ const getSponsorPlacement = (props)=>{
    const launchReg = new RegExp("launch", "i");
    const roundupReg = new RegExp("roundup", "i");
    const sponsoredArticleReg = new RegExp("sponsored-article", "i");
    const existingReg = new RegExp("existing-article-sponsorship", "i");
    const tierReg = new RegExp("tier", "i");
    const isActive = props.active;
    const isEmpty = props.product === "";
    const isExisting = existingReg.test(props.product);
    const isLaunch = launchReg.test(props.product);
    const isRoundup = roundupReg.test(props.product);
    const isSponsored = props.hasSponsorShip;
    const isSponsoredArticle = sponsoredArticleReg.test(props.product);
    const isTier = tierReg.test(props.product);
    const placement = {
        footer: [
            isSponsored,
            isActive,
            !isRoundup,
            !isEmpty
        ].every(Boolean),
        sidebar: [
            isSponsored,
            isActive,
            !isRoundup,
            !isEmpty
        ].every(Boolean),
        inline: [
            isSponsored,
            isActive,
            !isLaunch,
            !isEmpty
        ].every(Boolean),
        bio: [
            [
                isSponsored,
                isActive,
                !isTier,
                !isLaunch,
                !isExisting
            ].every(Boolean),
            [
                isSponsored,
                !isActive,
                !isTier,
                !isRoundup,
                !isSponsoredArticle,
                !isEmpty,
                !isExisting
            ].every(Boolean)
        ].some(Boolean)
    };
    return placement;
};
/**
 * Generates link and responsive image for the company logo.
 */ const Logo = (props)=>{
    const { cta , companyName , url , size , trackingData  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: (sponsorModule_module_default()).logoWrapper,
        href: cta,
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t3, {
            loading: "lazy",
            altText: `Sponsored by ${companyName}`,
            url: url,
            mode: "clip",
            mobileWidth: size * 2,
            mobileHeight: size * 2,
            extraProps: trackingData
        })
    });
};
/**
 * Generates the Sponsor Sidebar sometimes called the banner variant.
 */ const SponsorRecircSidebar = (props)=>{
    const { componentProps  } = props;
    const { sponsorWidgetProps  } = componentProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsoredRecircWidget, {
        ...sponsorWidgetProps
    });
};
/**
 * Generates the Sponsor Footer
 */ const SponsorRecircFooter = (props)=>{
    const { componentProps  } = props;
    const { sponsorWidgetProps  } = componentProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsoredRecircWidget, {
        ...sponsorWidgetProps
    });
};
/**
 * Generates the Sponsor Midway sometimes called the BIO variant.
 */ const SponsorBio = (props)=>{
    const { shortName , companyName , logoImage , legacyId , description , cta  } = props;
    const { article  } = (0,AppContext/* useAppState */.mr)();
    const LinkProps = {
        className: (sponsorModule_module_default()).callToAction,
        href: cta
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (sponsorModule_module_default()).iconMediaBlock,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                cta,
                shortName,
                companyName,
                url: logoImage,
                size: 75,
                trackingData: {
                    "data-tracking-event-type": "click",
                    "data-tracking-props": JSON.stringify({
                        sp_click_component: "insert",
                        sp_click_component_tile_type: "company_description",
                        sp_click_position: "footer",
                        sp_click_insert_type: "logo",
                        sp_click_target_page_position: "profile",
                        sp_page_type: "content",
                        sp_page_section: "advice",
                        sp_page_company_id: (0,strings/* getId */.zv)(legacyId).toString(),
                        sp_page_entity_id: article.id.toString() || null
                    })
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (sponsorModule_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        children: [
                            "Sponsored by\xa0",
                            companyName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule/* RichTextModule */.n, {
                        type: "richTextBlock",
                        richText: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                        ...LinkProps,
                        children: [
                            "See Company Profile",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "fa fa-angle-right"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/**
 * Creates one of the 3 sponsor Elements: sidebar, midway, footer
 */ const SponsorElement = ({ componentProps , active , sponsorLink , shortName , sponsorDescription , description , primaryImage , secondaryImage , tertiaryImage , logoImage , companyName , sponsorName , legacyId , size , sponsorType , id  })=>{
    let moduleTrackingProps = {};
    const cleanProps = {
        active,
        cta: sponsorLink || `/profiles/${shortName}`,
        description: sponsorDescription || description,
        primaryImage,
        secondaryImage,
        tertiaryImage,
        logoImage,
        companyName,
        sponsorName,
        legacyId,
        shortName,
        size,
        sponsorType,
        id,
        componentProps
    };
    if (sponsorType === "midway") {
        moduleTrackingProps = {
            "data-tracking-event-type": "impression",
            "data-tracking-props": JSON.stringify({
                sp_impression_component: "tile",
                sp_impression_tile_type: "company_description",
                sp_impression_position: "footer",
                sp_content_is_tile: false,
                sp_tile_entity_id: (0,strings/* getId */.zv)(legacyId).toString(),
                sp_tile_company_id: (0,strings/* getId */.zv)(legacyId).toString()
            })
        };
    } else if (sponsorType === "sidebar" || sponsorType === "footer") {
        moduleTrackingProps = {
            "data-tracking-event-type": "impression",
            "data-tracking-props": JSON.stringify({
                sp_impression_component: "insert",
                sp_impression_tile_type: null,
                sp_impression_position: "right_rail",
                sp_impression_insert_type: "sponsor_company_jobs",
                sp_content_is_tile: false,
                sp_tile_entity_id: null
            })
        };
    }
    const decisionTree = {
        sidebar: /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorRecircSidebar, {
            ...cleanProps
        }),
        midway: /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorBio, {
            ...cleanProps
        }),
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorRecircFooter, {
            ...cleanProps
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        className: (sponsorModule_module_default())[sponsorType],
        ...moduleTrackingProps,
        children: decisionTree[sponsorType]
    });
};
/**
 * Sponsor module business logic: which and if a module should load.
 * See business logic and layout at https://themuse.atlassian.net/l/c/XLUqU116
 * @example
 * import { SponsorModule } from "components/SponsorModule";
 * <SponsorModule {...{ type: "sidebar", ...props }} />
 * <SponsorModule {...{ type: "midway", ...props }} />
 * <SponsorModule {...{ type: "footer", ...props }} />
 */ const SponsorModule = (props)=>{
    const { active , hasSponsorShip , product , sponsorType  } = props;
    const placements = getSponsorPlacement({
        active,
        hasSponsorShip,
        product
    });
    const { footer , sidebar , bio  } = placements;
    const decisionTree = {
        footer: ()=>footer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorElement, {
                ...props
            }) : null,
        sidebar: ()=>sidebar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorElement, {
                ...props
            }) : null,
        midway: ()=>bio ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorElement, {
                ...props
            }) : null
    };
    return decisionTree[sponsorType] ? decisionTree[sponsorType]() : null;
};

;// CONCATENATED MODULE: ./src/components/SponsorInlineModule.tsx







/**
 * Creates an inline CTA module. This is a content module and is injected in Post process.
 * @example
 * import { SponsorInlineModule } from "components/SponsorInlineModule";
 * <SponsorInlineModule {...MOCK_Sponsor} />
 */ const SponsorInlineModule = ({ active , companyName , hasSponsorShip , id , legacyId , logoImage , shortName , product  })=>{
    const { publicRuntimeConfig: { pilboxHost , staticAssetHost  }  } = (0,config["default"])();
    const placements = getSponsorPlacement({
        active,
        hasSponsorShip,
        product
    });
    const roundupReg = new RegExp("roundup", "i");
    const isRoundup = roundupReg.test(product);
    const encodedUrl = encodeURIComponent(`${staticAssetHost}/${logoImage}`);
    const flags = "filter=antialias&mode=clip&opt=1&pos=top-left&prog=1&q=keep";
    const logoUrl = `${pilboxHost}/image.png?${flags}&url=${encodedUrl}&h=49&w=108`;
    const hasLogo = isRoundup;
    const logoClass = hasLogo ? (sponsorModule_module_default()).sponsorInlineLogo : " ";
    const moduleTrackingProps = {
        "data-oskar-view": "sponsoredCompanyTileViewed",
        "data-oskar-props": JSON.stringify({
            sp_impression_component: "tile",
            sp_impression_tile_type: "article_sponsor",
            sp_impression_position: "in_article",
            sp_page_section: "advice",
            sp_page_type: "content",
            sp_tile_entity_id: legacyId ? legacyId.toString() : null,
            sp_content_is_tile: false
        }),
        "data-tracking-event-type": "impression",
        "data-tracking-props": JSON.stringify({
            sp_impression_component: "tile",
            sp_impression_tile_type: "article_sponsor",
            sp_impression_position: "in_article",
            sp_page_section: "advice",
            sp_page_type: "content",
            sp_tile_entity_id: legacyId ? legacyId.toString() : null,
            sp_content_is_tile: false
        })
    };
    const clickTrackingProps = {
        sp_click_component_tile_type: "article_sponsor",
        sp_click_position: "in_article",
        sp_search_id: null,
        sp_page_type: "content",
        sp_page_section: "advice",
        sp_page_company_id: legacyId ? legacyId.toString() : null,
        sp_page_tab: null,
        sp_is_external_page: false,
        sp_page_entity_id: id
    };
    const profileTrackingProps = {
        ...clickTrackingProps,
        sp_click_component: "insert",
        sp_click_button_text: null,
        sp_click_target_page_position: "profile",
        sp_click_button_type: null,
        sp_click_insert_type: "logo"
    };
    const searchTrackingProps = {
        ...clickTrackingProps,
        sp_click_component: "button",
        sp_click_button_text: "learn more",
        sp_click_target_page_position: "search",
        sp_click_button_type: "job_search",
        sp_click_insert_type: null
    };
    const companyLogoProps = {
        className: (sponsorModule_module_default()).logoPill,
        companyUrl: `/profiles/${shortName}`,
        altText: `${companyName} Logo`,
        logoUrl,
        "data-tracking-props": JSON.stringify(profileTrackingProps),
        "data-tracking-event-type": "click"
    };
    const companyLogoTrackingProps = {
        "data-tracking-props": JSON.stringify(profileTrackingProps),
        "data-tracking-event-type": "click"
    };
    const SquareLinkButtonProps = {
        className: (sponsorModule_module_default()).squareButton,
        "data-tracking-props": JSON.stringify(searchTrackingProps),
        "data-tracking-event-type": "click",
        color: "mint",
        href: `/search/company/${shortName}`,
        target: "_blank"
    };
    return placements.inline ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        className: `${(articleContainer_module_default()).contentModule} ${(sponsorModule_module_default()).contentModule} ${(sponsorModule_module_default()).inline} ${logoClass}`,
        ...moduleTrackingProps,
        children: [
            hasLogo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogoOutlined/* default */.Z, {
                extraLinkProps: companyLogoTrackingProps,
                ...companyLogoProps
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (sponsorModule_module_default()).sponsorInlineEyebrow,
                children: "EXPLORE JOBS AT"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (sponsorModule_module_default()).sponsorInlineTitle,
                children: companyName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                ...SquareLinkButtonProps,
                children: "LEARN MORE"
            })
        ]
    }) : null;
};

// EXTERNAL MODULE: ./src/components/responsiveImageModule.module.scss
var responsiveImageModule_module = __webpack_require__(1536);
var responsiveImageModule_module_default = /*#__PURE__*/__webpack_require__.n(responsiveImageModule_module);
;// CONCATENATED MODULE: ./src/utils/jobQuizConfig.json
var jobQuizConfig_namespaceObject = JSON.parse('{"quizType":"job_quiz","quizId":"quiz","processingTitle":"Calculating your job matches...","reviewTitle":"This way to work that\'s worth it!","reviewRetakeText":"Retake Quiz","reviewViewResultsText":"View Results","questions":[{"questionId":"category","autoNav":true,"title":"Find the right job for you","details":"Let The Muse match you with a company culture that fits your goals and values. First, select your career path:","field":"keyword","fieldType":"buttonGroup","flow":true,"isRequired":false,"options":[{"display":"Marketing","value":"marketing"},{"display":"Sales","value":"sales"},{"display":"Data","value":"data"},{"display":"Human Resources","value":"human resources"},{"display":"Customer Service","value":"customer service"},{"display":"Software Engineering","value":"software engineering"},{"display":"Product Management","value":"product management"},{"display":"Education","value":"education"},{"display":"Design and UX","value":"design and ux"},{"display":"Administration","value":"administration"}]},{"questionId":"level","autoNav":true,"title":"How many years of experience do you have?","field":"level","fieldType":"buttonGroup","isRequired":false,"options":[{"display":"0 - 1 years","value":"entry"},{"display":"1 - 5 years","value":"mid"},{"display":"5 - 10+ years","value":"senior,executive"}]},{"questionId":"benefits","autoNav":false,"title":"What company benefits are most important to you?","field":"perks","fieldType":"multiSelectButtonGroup","flow":true,"isRequired":false,"options":[{"display":"Health Insurance","value":"health_insurance"},{"display":"Paid Vacation","value":"paid_vacation"},{"display":"Remote Work Opportunities","value":"remote_work_opportunities"},{"display":"Dental Insurance","value":"dental_insurance"},{"display":"401k With Matching","value":"401k_with_matching"},{"display":"Vision Insurance","value":"vision_insurance"},{"display":"Promote From Within","value":"promote_from_within"},{"display":"Flexible Work Hours","value":"flexible_work_hours"},{"display":"Personal Sick Days","value":"personal_sick_days"},{"display":"Performance Bonus","value":"performance_bonus"}]}],"showPrevious":true}');
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/BrandMark.tsx
var BrandMark = __webpack_require__(313);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/CurvedLine.tsx
var CurvedLine = __webpack_require__(8902);
// EXTERNAL MODULE: ./src/components/JobQuiz/JobQuizContainer.module.scss
var JobQuizContainer_module = __webpack_require__(6614);
var JobQuizContainer_module_default = /*#__PURE__*/__webpack_require__.n(JobQuizContainer_module);
;// CONCATENATED MODULE: ./src/components/JobQuiz/JobQuizNavigation.tsx




/**
 * Renders a navigation button group and progress bar for a job quiz.
 * Handles navigation between steps, skipping steps, and submitting the quiz.
 * Uses props to customize button texts, tracking data, and behavior.
 */ const JobQuizNavigation = (props)=>{
    const { galleryRef , currentStep , disableNext , nextText , numSteps , prevText , showPrevious , showNext , submitText , skipText , canSkip , clickTrackingData , onSkip , onStepChange , onSubmit  } = props;
    const [step, setStep] = react.useState(currentStep ?? 1);
    const [nextDisabled, setNextDisabled] = react.useState(disableNext ?? false);
    const willShowNext = typeof showNext === "undefined" ? true : !!showNext;
    const skippable = typeof canSkip === "undefined" ? true : !!canSkip;
    const willShowPrevious = showPrevious && step > 1;
    const percent = Math.floor(step / numSteps * 100);
    const progressStateStyle = {
        width: `${percent}%`
    };
    const nextAvailable = step < numSteps;
    const isLastStep = step === numSteps;
    const displayTextNext = isLastStep ? submitText : nextText;
    // automatically set the current step if it changes (this is useful for autonav and reset)
    react.useEffect(()=>{
        if (currentStep) {
            setStep(currentStep);
        }
    }, [
        currentStep
    ]);
    // When the step changes, we use the galleryRef to 'scroll' to the new question.
    react.useEffect(()=>{
        const gallery = galleryRef?.current;
        if (gallery) {
            const galleryWidth = gallery.clientWidth || 0;
            gallery.scrollTo({
                left: (step - 1) * galleryWidth,
                behavior: "smooth"
            });
        }
    }, [
        galleryRef,
        step
    ]);
    react.useEffect(()=>{
        if (typeof disableNext !== "undefined") {
            setNextDisabled(disableNext);
        }
    }, [
        disableNext
    ]);
    const handlePrevious = ()=>{
        if (!willShowPrevious) return;
        const newStep = step - 1;
        setStep(newStep);
        onStepChange?.(newStep);
    };
    const handleSkip = ()=>{
        if (!skippable) return;
        const newStep = step + 1;
        setStep(newStep);
        onSkip?.(newStep);
    };
    const handleNext = ()=>{
        if (!nextAvailable) return;
        if (nextDisabled) return;
        const newStep = step + 1;
        setStep(newStep);
        onStepChange?.(newStep);
    };
    const handleSubmit = ()=>{
        setStep(step + 1);
        onSubmit?.();
    };
    const previousButtonProps = {
        icon: "arrowLeft",
        position: "left",
        onClick: handlePrevious
    };
    const nextButtonProps = {
        disabled: nextDisabled && !isLastStep,
        onClick: handleNext
    };
    const submitButtonProps = {
        onClick: handleSubmit
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobQuizContainer_module_default()).navigation,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (JobQuizContainer_module_default()).progressBar,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (JobQuizContainer_module_default()).progressState,
                    style: progressStateStyle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (JobQuizContainer_module_default()).navButtons,
                children: [
                    willShowPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                        className: (JobQuizContainer_module_default()).prevButton,
                        "data-tracking-props": JSON.stringify({
                            ...clickTrackingData,
                            sp_click_button_text: prevText
                        }),
                        "data-tracking-event-type": "click",
                        ...previousButtonProps,
                        children: prevText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (JobQuizContainer_module_default()).spacer
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (JobQuizContainer_module_default()).navRight,
                        children: [
                            skippable && !isLastStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                                className: (JobQuizContainer_module_default()).prevButton,
                                onClick: handleSkip,
                                "data-tracking-props": JSON.stringify({
                                    ...clickTrackingData,
                                    sp_click_button_text: skipText
                                }),
                                "data-tracking-event-type": "click",
                                children: skipText
                            }),
                            willShowNext && !isLastStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                                className: (JobQuizContainer_module_default()).nextButton,
                                ...nextButtonProps,
                                "data-tracking-props": JSON.stringify({
                                    ...clickTrackingData,
                                    sp_click_button_text: displayTextNext
                                }),
                                "data-tracking-event-type": "click",
                                children: displayTextNext
                            }),
                            isLastStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                                className: (JobQuizContainer_module_default()).nextButton,
                                ...submitButtonProps,
                                "data-tracking-props": JSON.stringify({
                                    ...clickTrackingData,
                                    sp_click_button_text: submitText,
                                    sp_click_target_page_section: "search"
                                }),
                                "data-tracking-event-type": "click",
                                children: submitText
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
JobQuizNavigation.displayName = "JobQuizNavigation";
/**
 * Wraps the JobQuizNavigation so we can pass a Ref to it as a child element..
 */ const JobQuizNavigationRef = /*#__PURE__*/ react.forwardRef((props, ref)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(JobQuizNavigation, {
        galleryRef: ref,
        ...props
    }));
JobQuizNavigationRef.displayName = "JobQuizNavigationRef";



;// CONCATENATED MODULE: ./src/components/JobQuiz/JobQuizInputs.tsx



/**
 * Renders a Multiple select options group.
 */ const MultiSelectButtonGroup = (props)=>{
    const { choices , field , flow , onSelect , clickTrackingData  } = props;
    const [selectedItems, setSelectedItems] = react.useState([]);
    const containerClasses = `${(JobQuizContainer_module_default()).buttonGroup} ${flow ? (JobQuizContainer_module_default()).buttonGroup__flow : ""}`;
    const inputClasses = `${(JobQuizContainer_module_default()).buttonGroup__item} ${(JobQuizContainer_module_default()).multiSelectItem}`;
    const handleChange = ($evt)=>{
        const { value , checked  } = $evt.target;
        $evt.target.blur();
        let newSelections = Object.assign([], selectedItems);
        if (checked && !selectedItems.includes(value)) {
            newSelections.push(value);
        }
        if (!checked && selectedItems.includes(value)) {
            newSelections = selectedItems.filter((item)=>item !== value);
        }
        setSelectedItems(newSelections);
        onSelect?.(newSelections);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: containerClasses,
        children: choices.map((option)=>{
            const tracking = {
                ...clickTrackingData
            };
            tracking.sp_quiz_answer = option.value;
            tracking.sp_click_button_text = option.display ? option.display : option.value;
            return(// eslint-disable-next-line jsx-a11y/label-has-associated-control
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: inputClasses,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        name: field ?? "multiselect-button-group",
                        value: option.value,
                        onChange: handleChange,
                        "data-tracking-props": JSON.stringify(tracking),
                        "data-tracking-event-type": "click"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (JobQuizContainer_module_default()).inputTitle,
                        children: option.display ? option.display : option.value
                    })
                ]
            }, option.value));
        })
    });
};
/**
 * Renders a group of radio buttons as a button group.
 */ const ButtonGroup = (props)=>{
    const { choices , field , flow , clickTrackingData , onSelect  } = props;
    const [, setSelectedItem] = react.useState("");
    const containerClasses = `${(JobQuizContainer_module_default()).buttonGroup} ${flow ? (JobQuizContainer_module_default()).buttonGroup__flow : ""}`;
    const handleChange = ($evt)=>{
        const { value  } = $evt.target;
        setSelectedItem(value);
        onSelect?.(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: containerClasses,
        children: choices.map((option)=>{
            const tracking = {
                ...clickTrackingData
            };
            tracking.sp_quiz_answer = option.value;
            tracking.sp_click_button_text = option.display ? option.display : option.value;
            return(// eslint-disable-next-line jsx-a11y/label-has-associated-control
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: (JobQuizContainer_module_default()).buttonGroup__item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "radio",
                        name: field ?? "button-group",
                        value: option.value,
                        onChange: handleChange,
                        "data-tracking-props": JSON.stringify(tracking),
                        "data-tracking-event-type": "click"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (JobQuizContainer_module_default()).inputTitle,
                        children: option.display ? option.display : option.value
                    })
                ]
            }, option.value));
        })
    });
};
ButtonGroup.displayName = "ButtonGroup";


;// CONCATENATED MODULE: ./src/components/JobQuiz/JobQuizQuestion.tsx




/**
 * Renders a question in the job quiz.
 */ const JobQuizQuestion = (props)=>{
    const { details , field , fieldType , flow , options , title , questionId , extraClass , clickTrackingData , onResponseChange  } = props;
    const handleSelect = (selections)=>{
        const questionData = {
            questionId,
            response: selections
        };
        if (field) {
            questionData.field = field;
        }
        onResponseChange?.(questionData);
    };
    const inputComponent = ()=>{
        const inputProps = {
            field,
            flow,
            choices: options,
            onSelect: handleSelect
        };
        let Component = null;
        switch(fieldType){
            case "multiSelectButtonGroup":
                Component = /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectButtonGroup, {
                    ...inputProps,
                    clickTrackingData: clickTrackingData
                });
                break;
            default:
                Component = /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup, {
                    ...inputProps,
                    clickTrackingData: clickTrackingData
                });
                break;
        }
        return Component;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (JobQuizContainer_module_default()).contentBody,
            extraClass
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (JobQuizContainer_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (JobQuizContainer_module_default()).details,
                children: details
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (JobQuizContainer_module_default()).inputs,
                children: inputComponent()
            })
        ]
    });
};
JobQuizQuestion.displayName = "JobQuizQuestion";


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Text/TextLink.tsx + 1 modules
var TextLink = __webpack_require__(9820);
;// CONCATENATED MODULE: ./src/components/JobQuiz/JobQuizReview.tsx





/**
 * Renders a JobQuizProcessing component for displaying processing state during quiz completion.
 * Handles loading state, displays processing title, loading images, and triggers result view.
 */ const JobQuizProcessing = (props)=>{
    const { delay , processingTitle , reviewTitle , reviewRetakeText , reviewViewResultsText , showProcessing , clickTrackingData , onViewResults , onReset  } = props;
    const [loading, setLoading] = react.useState(true);
    const Image1 = "https://assets.themuse.com/images/job-quiz-image-01.webp";
    const Image2 = "https://assets.themuse.com/images/job-quiz-image-02.webp";
    const Image3 = "https://assets.themuse.com/images/job-quiz-image-03.webp";
    const LoadingGif = "https://assets.themuse.com/images/job-quiz-loading.webp";
    const inViewClass = showProcessing ? (JobQuizContainer_module_default()).viewer : "";
    react.useEffect(()=>{
        if (showProcessing) {
            const timeout = delay ?? 2000;
            setTimeout(()=>{
                setLoading(false);
                onViewResults?.();
            }, timeout);
        } else {
            setLoading(true);
        }
    }, [
        delay,
        onViewResults,
        showProcessing
    ]);
    return loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (JobQuizContainer_module_default()).contentBody,
            inViewClass
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: `${(JobQuizContainer_module_default()).title} ${(JobQuizContainer_module_default()).center}`,
                children: processingTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (JobQuizContainer_module_default()).loadingBody,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (JobQuizContainer_module_default()).loadingGif,
                        src: LoadingGif,
                        alt: "loading...",
                        height: "105",
                        width: "105",
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (JobQuizContainer_module_default()).imageBubble_1,
                        src: Image1,
                        alt: "Woman interviewing",
                        height: "75",
                        width: "75",
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (JobQuizContainer_module_default()).imageBubble_2,
                        src: Image2,
                        alt: "Woman laughing",
                        height: "100",
                        width: "100",
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (JobQuizContainer_module_default()).imageBubble_3,
                        src: Image3,
                        alt: "Man and woman smiling",
                        height: "100",
                        width: "100",
                        loading: "lazy"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(JobQuizReview, {
        reviewTitle: reviewTitle,
        reviewRetakeText: reviewRetakeText,
        reviewViewResultsText: reviewViewResultsText,
        showReview: !loading,
        onResult: onViewResults,
        onReset: onReset,
        clickTrackingData: clickTrackingData
    });
};
JobQuizProcessing.displayName = "JobQuizProcessing";
/**
 * Renders a review section of a job quiz.
 */ const JobQuizReview = (props)=>{
    const { reviewTitle , reviewRetakeText , reviewViewResultsText , showReview , clickTrackingData , onResult =()=>{} , onReset =()=>{}  } = props;
    const extraClass = showReview ? (JobQuizContainer_module_default()).viewer : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (JobQuizContainer_module_default()).contentBody,
            extraClass
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: `${(JobQuizContainer_module_default()).title} ${(JobQuizContainer_module_default()).center}`,
                children: reviewTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (JobQuizContainer_module_default()).loadingBody,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                        className: (JobQuizContainer_module_default()).primaryCta,
                        onClick: onResult,
                        "data-tracking-props": JSON.stringify({
                            ...clickTrackingData,
                            sp_click_button_text: reviewViewResultsText,
                            sp_click_target_page_section: "search"
                        }),
                        "data-tracking-event-type": "click",
                        children: reviewViewResultsText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* default */.Z, {
                        className: (JobQuizContainer_module_default()).secondaryCta,
                        onClick: onReset,
                        "data-tracking-props": JSON.stringify({
                            ...clickTrackingData,
                            sp_click_button_text: reviewRetakeText
                        }),
                        "data-tracking-event-type": "click",
                        children: reviewRetakeText
                    })
                ]
            })
        ]
    });
};
JobQuizReview.displayName = "JobQuizReview";


;// CONCATENATED MODULE: ./src/components/JobQuiz/JobQuizContainer.tsx

/* eslint-disable camelcase */ 






/**
 * Generates a random string of 6 characters using uppercase letters, lowercase letters, and digits.
 */ const randomString = ()=>{
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const charactersLength = characters.length;
    for(let i = 0; i < 6; i += 1){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
/**
 * A Job Quiz container that manages the state of the quiz, question responses, tracking data, and navigation.
 */ const JobQuizContainer = (props)=>{
    const { showPrevious , submitText ="submit" , nextText ="continue" , prevText ="back" , skipText ="skip" , quizType ="quiz" , questions , processingTitle ="Calculating your job matches..." , reviewTitle ="This way to work that's worth it" , reviewRetakeText ="Retake Quiz" , reviewViewResultsText ="View Results" , trackingOverrides , clickTrackingOverrides , onSubmit  } = props;
    const ref = react.useRef(null); // Updates tracking props on the container
    const galleryRef = react.useRef(null); // Handles the cycling of questions
    const [activeIndex, setActiveIndex] = react.useState(0); // 0 based index representing the current question being shown
    const [responses, setResponses] = react.useState([]); // Array containing all question responses
    const [showReview, setShowReview] = react.useState(false); // True when the quiz is 'complete' to show or hide the review screen
    const [impressionId, setImpressionId] = react.useState(""); // Random alphanumeric string to show a unique quiz view
    const [impressionCount, setImpressionCount] = react.useState(1); // # of attempts (updated when 'retake' is clicked)
    const activeQuestion = questions[activeIndex];
    const activeQuestionId = activeQuestion.questionId || `question-${activeIndex + 1}`;
    // useMemo so this is not recalculated on every re-render
    const initialTracking = react.useMemo(()=>({
            sp_quiz_type: quizType || "quiz",
            sp_quiz_id: `${impressionId}-${impressionCount}`,
            sp_quiz_question_name: activeQuestionId,
            sp_quiz_question_order: activeIndex + 1,
            ...trackingOverrides || {}
        }), [
        activeIndex,
        activeQuestionId,
        impressionCount,
        impressionId,
        quizType,
        trackingOverrides
    ]);
    // useMemo so this is not recalculated on every re-render
    const initialClickTracking = react.useMemo(()=>({
            ...initialTracking,
            sp_click_button_type: "job_quiz_answer",
            sp_click_component: "button",
            sp_click_tile_type: null,
            sp_click_insert_type: "job_quiz",
            sp_click_button_text: "explore open jobs",
            sp_click_position: "second_para",
            sp_click_target_page_section: null,
            ...clickTrackingOverrides
        }), [
        clickTrackingOverrides,
        initialTracking
    ]);
    const [trackingData, setTrackingData] = react.useState(initialTracking);
    const [clickTrackingData, setClickTrackingData] = react.useState(initialClickTracking);
    // When the quiz loads create the impression Id. This should only ever happen once on load.
    // This is in a useEffect to prevent resetting it on the server and client.
    react.useEffect(()=>{
        const impressionStr = randomString();
        setImpressionId(impressionStr);
    }, []);
    // If any tracking data changes set it to the state to pass into the buttons
    react.useEffect(()=>{
        setTrackingData({
            ...initialTracking,
            sp_quiz_id: `${impressionId}-${impressionCount}`
        });
        setClickTrackingData({
            ...initialClickTracking,
            sp_quiz_id: `${impressionId}-${impressionCount}`
        });
    }, [
        impressionCount,
        initialClickTracking,
        initialTracking,
        impressionId
    ]);
    const numSteps = questions.length || 0;
    const quizData = {
        quizType: quizType || "quiz",
        quizId: `${impressionId}-${impressionCount}`,
        questions: responses
    };
    // This is to update the question shown (convert the step to 0 based index)
    const handleStepChange = (step)=>{
        const index = step - 1;
        setActiveIndex(index);
    };
    const resetQuiz = ()=>{
        setActiveIndex(0);
        setShowReview(false);
        setResponses([]);
        const newCount = impressionCount + 1;
        setImpressionCount(newCount);
        if (ref?.current) {
            ref.current.removeAttribute("data-track");
            ref.current.removeAttribute("data-previous-question");
        }
    };
    const submitQuiz = ()=>{
        if (onSubmit) {
            onSubmit(quizData);
        }
    };
    const completeQuiz = ()=>{
        if (ref?.current) {
            ref.current.setAttribute("data-track", JSON.stringify(quizData));
        }
        setShowReview(true);
    };
    // Updates the responses state variable (updates or adds the value depending on whether it exists)
    // Also handles the navigation if autonav is true for the question
    const onQuestionResponse = (value, skipped = false)=>{
        const newResponses = Object.assign([], responses);
        const foundResponse = newResponses.findIndex((elem)=>elem.questionId === value.questionId);
        if (foundResponse > -1) {
            newResponses[foundResponse] = value;
        } else {
            newResponses.push(value);
        }
        setResponses(newResponses);
        if (activeQuestion.autoNav || skipped) {
            handleStepChange(activeIndex + 2); // Set the step to the current index + 2 (current step is index + 1)
        }
    };
    const handleSkip = ()=>{
        const questionResponse = {
            questionId: activeQuestionId,
            questionOrder: activeIndex + 1,
            field: activeQuestion.field,
            response: null
        };
        onQuestionResponse(questionResponse, true);
    };
    const disableNext = !responses.some((elem)=>elem.questionId === activeQuestionId);
    const quizNavProps = {
        currentStep: activeIndex + 1,
        numSteps,
        nextText,
        disableNext,
        prevText,
        showPrevious: showPrevious && !showReview,
        submitText,
        canSkip: !activeQuestion.isRequired,
        showNext: !activeQuestion.autoNav && !showReview,
        onSkip: handleSkip,
        onStepChange: handleStepChange,
        onSubmit: completeQuiz,
        galleryRef,
        skipText
    };
    const renderQuestions = ()=>questions.map((question, index)=>{
            const questionId = question?.questionId ?? `question-${index + 1}`;
            const viewerClass = index === activeIndex && !showReview ? (JobQuizContainer_module_default()).viewer : "";
            const clickTracking = {
                ...clickTrackingData
            };
            clickTracking.sp_quiz_question_name = questions[index].questionId ?? `question-${index + 1}`;
            clickTracking.sp_quiz_question_order = index + 1;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobQuizQuestion, {
                ...question,
                trackingData: trackingData,
                clickTrackingData: clickTracking,
                extraClass: viewerClass,
                questionId: questionId,
                onResponseChange: onQuestionResponse
            }, `${impressionId}-${impressionCount}-${questionId}`);
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: (JobQuizContainer_module_default()).container,
        "data-tracking-event-type": "impression",
        "data-tracking-props": JSON.stringify(trackingData),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: galleryRef,
                className: (JobQuizContainer_module_default()).gallery,
                children: [
                    renderQuestions(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobQuizProcessing, {
                        processingTitle: processingTitle,
                        reviewTitle: reviewTitle,
                        reviewRetakeText: reviewRetakeText,
                        reviewViewResultsText: reviewViewResultsText,
                        showProcessing: showReview,
                        onViewResults: ()=>{
                            submitQuiz();
                        },
                        onReset: resetQuiz,
                        clickTrackingData: clickTrackingData
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobQuizNavigationRef, {
                ...quizNavProps,
                clickTrackingData: clickTrackingData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedLine/* default */.Z, {
                className: (JobQuizContainer_module_default()).curvedLine
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandMark/* default */.Z, {
                className: (JobQuizContainer_module_default()).brandMark
            })
        ]
    });
};
JobQuizContainer.displayName = "JobQuizContainer";


;// CONCATENATED MODULE: ./src/components/JobQuizModule.tsx






/**
 * Creates an inline CTA module. This is a content module and is injected in Post process.
 * @example
 * import { SponsorInlineModule } from "components/SponsorInlineModule";
 * <SponsorInlineModule {...MOCK_Sponsor} />
 */ const JobQuizModule = ()=>{
    const { article  } = (0,AppContext/* useAppState */.mr)();
    const onQuizSubmit = (responses)=>{
        const filtersFromResponses = [];
        responses.questions.forEach((elem)=>{
            let answers = "";
            if (elem.response === null) {
                return;
            }
            if (Array.isArray(elem.response)) {
                answers = elem.response.join();
            } else {
                answers = elem.response;
            }
            filtersFromResponses.push(`${elem.field}=${answers}`);
        });
        const searchUrl = `/search?${filtersFromResponses.join("&")}`;
        window.open(searchUrl, "_blank");
    };
    const jobQuizProps = {
        ...jobQuizConfig_namespaceObject,
        trackingOverrides: {
            sp_impression_component: "insert",
            sp_impression_insert_type: "job_quiz",
            sp_impression_position: "second_para",
            sp_page_type: "content",
            sp_page_section: "advice",
            sp_page_company_id: null,
            sp_page_tab: null,
            sp_page_is_external: false
        },
        onSubmit: onQuizSubmit
    };
    const excludedUrls = [
        "interview-questions-and-answers"
    ];
    const excludedCategories = [
        "vibe-awards"
    ];
    const showJobQuiz = !excludedUrls.includes(article?.slug) && !excludedCategories.includes(article?.categorySlug) && !article.sponsor.id;
    return showJobQuiz ? /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        className: `${(articleContainer_module_default()).contentModule}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobQuizContainer, {
            ...jobQuizProps
        })
    }) : null;
};

// EXTERNAL MODULE: ./src/components/TrendingSearch.tsx
var TrendingSearch = __webpack_require__(908);
;// CONCATENATED MODULE: ./src/components/ContentMapper.tsx















const JumpLink = (props)=>{
    const { id  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        id: `${id}`,
        className: "jump-link"
    });
};
/**
 * Returns a heading either h2 or h3.
 * * If position is passed this is a bullet heading and will also contain numbering.
 * * If a prefix is passed we render the prefix before the number.
 * * If a prefix is passed the suffix of the number becomes a colon.
 * * If header is not passed we render nothing.
 * * If size is passed we render an H3.
 */ const HeadingModule = (props)=>{
    const { prefix , heading , position , size , headerClassName  } = props;
    const intro = position ? `${prefix || ""} ${position}${prefix ? ": " : ". "}`.trim() : "";
    const content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            intro.length ? `${intro} ` : "",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule/* RichTextModule */.n, {
                className: "inline",
                type: "richTextBlock",
                richText: heading
            })
        ]
    });
    return size ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: headerClassName,
        children: content
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
        className: headerClassName,
        children: content
    });
};
const getResponsiveImage = (props)=>{
    const { alignment ="left" , image  } = props;
    const { height , width , url , altText , credit , creditLink  } = image;
    // Because caption can be overwritten in the template.
    const caption = props.caption || image.caption || "";
    const aspect = height / width;
    const sizes = {
        xs: 313,
        sm: 630,
        md: 630,
        lg: 515,
        xl: 780
    };
    const mobileWidth = Math.ceil(width >= sizes.xs ? sizes.xs : width);
    const tabletWidth = Math.ceil(width >= sizes.sm ? sizes.sm : width);
    const laptopWidth = Math.ceil(width >= sizes.md ? sizes.md : width);
    const desktopWidth = Math.ceil(width >= sizes.lg ? sizes.lg : width);
    const bigScreenWidth = Math.ceil(width >= sizes.xl ? sizes.xl : width);
    const mobileHeight = Math.ceil(mobileWidth * aspect);
    const tabletHeight = Math.ceil(tabletWidth * aspect);
    const laptopHeight = Math.ceil(laptopWidth * aspect);
    const desktopHeight = Math.ceil(desktopWidth * aspect);
    const bigScreenHeight = Math.ceil(bigScreenWidth * aspect);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
        className: `${(responsiveImageModule_module_default()).articleBodyImageModule} ${(responsiveImageModule_module_default())[`pull${alignment}`]}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (responsiveImageModule_module_default()).imageWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t3, {
                altText,
                bigScreenHeight,
                bigScreenWidth,
                caption,
                credit,
                creditLink,
                desktopHeight,
                desktopWidth,
                laptopHeight,
                laptopWidth,
                loading: "lazy",
                mobileHeight,
                mobileWidth,
                tabletHeight,
                tabletWidth,
                url
            })
        })
    });
};
// The following linter issue is a bug in eslint
// eslint-disable-next-line no-undef
const ContentMapper = (props)=>{
    const { modules =[] , hasBullets , prefix , tocEntities  } = props;
    const hasDividers = modules?.some((module)=>module && module.type === "divider");
    let position = 0;
    let companyOrder = 0;
    const annotatedModules = modules?.map((module)=>{
        if (module.type === "companyProfileBlock") {
            companyOrder += 1;
            return {
                ...module,
                orderNum: companyOrder
            };
        }
        return module;
    });
    return annotatedModules?.map((module)=>{
        const { heading , type , id , inToc  } = module;
        const size = !hasDividers || type === "divider";
        const hasBullet = !!heading && type !== "divider";
        const headerClassName = props.templateName === "listicle" ? "listicle-header" : null;
        position = hasBullets && hasBullet ? position + 1 : position;
        const HeadingProps = {
            prefix: hasBullets && hasBullet ? prefix : "",
            position: hasBullet ? position : 0,
            size,
            heading,
            id,
            headerClassName
        };
        const content = {
            richTextBlock: (moduleProps)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule/* RichTextModule */.n, {
                    ...moduleProps
                }),
            blockquoteBlock: (moduleProps)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuoteModule, {
                    ...moduleProps
                }),
            htmlBlock: (moduleProps)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlModule, {
                    ...moduleProps
                }),
            embedBlock: (moduleProps)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(EmbedModule, {
                    template: "article",
                    ...moduleProps
                }),
            jwVideoBlock: (moduleProps)=>moduleProps.jwVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(JWVideoModule, {
                    ...moduleProps
                }),
            companyProfileBlock: (moduleProps)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyModule, {
                    ...moduleProps,
                    isArticle: !hasBullets,
                    orderNum: module.orderNum
                }),
            divider: (moduleProps)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DividerModule, {
                    ...moduleProps
                }),
            imageBlock: getResponsiveImage,
            tocGenerator: (moduleProps)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TocModule, {
                    entities: tocEntities,
                    ...moduleProps
                }),
            sponsorInlineBlock: (moduleProps)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorInlineModule, {
                    ...moduleProps
                }),
            jobQuizBlock: (moduleProps)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(JobQuizModule, {
                    ...moduleProps
                }),
            trendingSearchBlock: (moduleProps)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingSearch.TrendingSearch, {
                    ...moduleProps
                })
        };
        return content[module.type] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                inToc && /*#__PURE__*/ (0,jsx_runtime.jsx)(JumpLink, {
                    id
                }),
                heading && module.type !== "divider" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingModule, {
                    ...HeadingProps
                }),
                " ",
                content[module.type](module)
            ]
        }, id);
    }) ?? [];
};

;// CONCATENATED MODULE: ./src/utils/images.ts
const initLazyImages = ()=>{
    const lazyLoadImages = document.querySelectorAll("img[defer-src]:not([src]), img[data-src]:not([src])");
    Array.from(lazyLoadImages).forEach((el)=>{
        el.setAttribute("loading", "lazy");
        el.setAttribute("src", el.dataset.src ?? el.getAttribute("defer-src"));
        el.setAttribute("srcSet", el.dataset.srcset);
    });
};

// EXTERNAL MODULE: ./src/utils/observer.ts
var observer = __webpack_require__(8765);
;// CONCATENATED MODULE: ./src/components/ArticleBody.tsx






/**
 * Tracks video impressions by observing the given HTMLDivElement element.
 *
 * @param el - The HTMLDivElement element to observe for video impressions.
 * @returns void
 */ const trackVideoImpressions = (el)=>{
    const impressionObserver = (0,observer/* getObserver */.C)(build.triggerSnowplowImpressionEvent);
    impressionObserver.observe(el);
};
// only video elements that have not been initialized with tracking props.
const selector = 'div[itemtype="https://schema.org/VideoObject"]:not([data-tracking-props="*"])';
/**
 * Sets the tracking properties for a video wrapper element.
 *
 * @param {HTMLDivElement} wrapper - The video wrapper element.
 * @returns {void}
 */ const setTrackingProps = (wrapper)=>{
    const scriptEl = wrapper.querySelector("script");
    const id = scriptEl.src.split("/players/")[1].split("-")[0];
    const metaEl = wrapper.querySelector('meta[itemprop="name"]');
    const title = metaEl.content;
    const content = JSON.stringify({
        sp_impression_component: "insert",
        sp_impression_insert_type: "media",
        sp_impression_position: "in_article",
        sp_media_type: "video",
        sp_media_name: title,
        sp_media_provider_key: id,
        sp_media_provider_name: "jwplayer"
    });
    wrapper.setAttribute("data-tracking-props", content);
    wrapper.setAttribute("data-tracking-event-type", "impression");
};
/**
 * Renders the body of an article.
 *
 * @param {ArticleBodyProps} props - The props for the ArticleBody component.
 * @param {ContentModule[]} props.articleContentModules - The content modules for the article.
 * @param {string} [props.blockHeadingPrefix] - The prefix for block headings.
 * @param {ContentModule[]} [props.listBuilder] - The content modules for the list builder.
 * @param {ContentModule[]} [props.postListBodyContent] - The content modules for the post list body.
 * @param {string} props.templateName - The template name.
 * @param {Array<{ heading: string; id: number }>} props.tocEntities - The table of contents entities.
 * @returns {JSX.Element} The rendered ArticleBody component.
 */ const ArticleBody = (props)=>{
    const { articleContentModules , blockHeadingPrefix , listBuilder , postListBodyContent , templateName , tocEntities  } = props;
    const contentProps = {
        modules: articleContentModules,
        templateName,
        tocEntities
    };
    const listBuilderProps = {
        modules: listBuilder,
        templateName,
        hasBullets: true,
        prefix: blockHeadingPrefix
    };
    const postBodyProps = {
        modules: postListBodyContent,
        templateName
    };
    (0,react.useEffect)(()=>{
        const elements = document.querySelectorAll(selector);
        if (elements.length) {
            Array.from(elements).forEach((el)=>{
                el.addEventListener("click", ()=>(0,build.triggerSnowplowVideoEvent)("play", el), {
                    once: true
                });
                setTrackingProps(el);
                trackVideoImpressions(el);
            });
        }
        initLazyImages();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ContentMapper(contentProps),
            listBuilder && ContentMapper(listBuilderProps),
            postListBodyContent && ContentMapper(postBodyProps)
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/ArticleContent.tsx







const DynamicAuthorModule = dynamic_default()(()=>__webpack_require__.e(/* import() */ 346).then(__webpack_require__.bind(__webpack_require__, 2346)).then((x)=>x.AuthorModule), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2346)
            ]
    },
    ssr: false
});
const ArticleContent = (props)=>{
    const { articleContentModules , blockHeadingPrefix , listBuilder , postListBodyContent , sponsorModuleProps , templateName , author ,  } = props;
    // tocEntities is a collection of all the objects passed to the article in each of the 3 sections.
    // These are used only in the first section to discover the needed elements from the full page to build a TOC.
    const tocEntities = getTOCEntries([].concat(articleContentModules, listBuilder, postListBodyContent));
    const bodyProps = {
        articleContentModules,
        blockHeadingPrefix,
        listBuilder,
        postListBodyContent,
        templateName,
        tocEntities
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (articleContainer_module_default()).articleContent,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (articleContainer_module_default()).contentModule,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleBody, {
                    ...bodyProps
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorModule, {
                    sponsorType: "footer",
                    ...sponsorModuleProps
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAuthorModule, {
                    ...author
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/newsletterJobAlerts.constants.ts
var newsletterJobAlerts_constants = __webpack_require__(7915);
;// CONCATENATED MODULE: ./src/components/ArticleContainer.tsx











const DynamicRecentArticles = dynamic_default()(()=>__webpack_require__.e(/* import() */ 857).then(__webpack_require__.bind(__webpack_require__, 6857)).then((x)=>x.RecentArticles), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6857)
            ]
    },
    ssr: false
});
const DynamicNewsletterCard = dynamic_default()(()=>__webpack_require__.e(/* import() */ 250).then(__webpack_require__.bind(__webpack_require__, 6250)).then((x)=>x.NewsletterCard), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6250)
            ]
    },
    ssr: false
});
const NewsletterJobAlerts = dynamic_default()(()=>__webpack_require__.e(/* import() */ 258).then(__webpack_require__.bind(__webpack_require__, 6258)).then((x)=>x.NewsletterJobAlerts), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6258)
            ]
    },
    ssr: false
});
const ArticleContainer = ()=>{
    const { article  } = (0,AppContext/* useAppState */.mr)();
    const { articleContentModules , articleUri , blockHeadingPrefix , breadcrumbLinks , contentAuthor , leadMedia , listBuilder , listicleContentType , postListBodyContent , product , slug , sponsor , tags , templateName , title , componentProps , dateUpdated , postDate , primaryTopic  } = article;
    const social = {
        articleUri,
        slug,
        title,
        writerName: contentAuthor?.writerName,
        writerSlug: contentAuthor?.writerSlug,
        twitterHandle: contentAuthor?.twitterHandle,
        dateUpdated: dateUpdated ?? postDate
    };
    const author = {
        articleUri,
        slug,
        title,
        ...contentAuthor
    };
    const sponsorModuleProps = {
        listicleContentType,
        tags,
        product,
        ...sponsor,
        componentProps
    };
    const articleContentProps = {
        articleContentModules,
        postListBodyContent,
        blockHeadingPrefix,
        listBuilder,
        templateName,
        sponsorModuleProps: {
            ...sponsorModuleProps
        },
        author,
        dateUpdated,
        postDate
    };
    const [newsletterCardViewed, setNewsletterCardViewed] = react.useState(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: (articleContainer_module_default()).article,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (articleContainer_module_default()).articleContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleHeader, {
                    articleTitle: title,
                    breadcrumbs: breadcrumbLinks
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (articleContainer_module_default()).articleBannerFlexContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (articleContainer_module_default()).articleBody,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSocial, {
                                ...social
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (articleContainer_module_default()).articleBodyWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (articleContainer_module_default()).articleContentWrapper,
                                        children: [
                                            leadMedia && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadMediaModule, {
                                                ...leadMedia,
                                                showPinterest: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleContent, {
                                                ...articleContentProps
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorModule, {
                                                sponsorType: "midway",
                                                ...sponsorModuleProps
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (articleContainer_module_default()).articlePostBodyWrapper,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterJobAlerts, {
                                                        className: (articleContainer_module_default()).newsJobAlertsMobile,
                                                        trackingData: newsletterJobAlerts_constants/* trackingData */.Kk
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicRecentArticles, {
                                                        primaryTopic: primaryTopic
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (articleContainer_module_default()).rightRailWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (articleContainer_module_default()).rightRail,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorModule, {
                                                    sponsorType: "sidebar",
                                                    ...sponsorModuleProps
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterJobAlerts, {
                                                    trackingData: newsletterJobAlerts_constants/* trackingData */.Kk
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/hooks/subNavStatic.ts
const subNavItems = {
    items: [
        {
            title: "Job Search",
            uri: "/advice/job-search",
            children: [
                {
                    title: "Finding a Job",
                    uri: "/advice/finding-a-job"
                },
                {
                    title: "Resumes",
                    uri: "/advice/resumes",
                    children: [
                        {
                            title: "Resume Examples",
                            uri: "/advice/resume-examples"
                        }
                    ]
                },
                {
                    title: "Cover Letters",
                    uri: "/advice/cover-letters"
                },
                {
                    title: "Networking",
                    uri: "/advice/networking"
                },
                {
                    title: "Interviewing",
                    uri: "/advice/interviewing"
                },
                {
                    title: "Job Offer",
                    uri: "/advice/job-offer"
                }
            ]
        },
        {
            title: "Career Paths",
            uri: "/advice/career-paths",
            children: [
                {
                    title: "Exploring Careers",
                    uri: "/advice/exploring-careers",
                    children: [
                        {
                            title: "Careers in Data and Analytics",
                            uri: "/advice/data-science-analytics"
                        },
                        {
                            title: "Careers in Finance",
                            uri: "/advice/finance"
                        },
                        {
                            title: "Careers in Marketing",
                            uri: "/advice/marketing"
                        },
                        {
                            title: "Careers in Sales",
                            uri: "/advice/sales"
                        },
                        {
                            title: "Careers in Software Engineering",
                            uri: "/advice/software-engineering"
                        }
                    ]
                },
                {
                    title: "Career Stories",
                    uri: "/advice/career-stories"
                },
                {
                    title: "Career Change",
                    uri: "/advice/career-change"
                },
                {
                    title: "Training and Development",
                    uri: "/advice/training-development"
                }
            ]
        },
        {
            title: "Succeeding at Work",
            uri: "/advice/succeeding-at-work",
            children: [
                {
                    title: "Work and COVID-19",
                    uri: "/advice/work-and-coronavirus-covid-19"
                },
                {
                    title: "Productivity",
                    uri: "/advice/productivity"
                },
                {
                    title: "Getting Ahead",
                    uri: "/advice/getting-ahead"
                },
                {
                    title: "Work Relationships",
                    uri: "/advice/work-relationships"
                },
                {
                    title: "Work-Life Balance",
                    uri: "/advice/work-life-balance",
                    children: [
                        {
                            title: "Working Parents",
                            uri: "/advice/working-parents"
                        },
                        {
                            title: "Remote Work",
                            uri: "/advice/remote-work"
                        }
                    ]
                },
                {
                    title: "Money",
                    uri: "/advice/money"
                },
                {
                    title: "Changing Jobs",
                    uri: "/advice/changing-jobs"
                },
                {
                    title: "Management",
                    uri: "/advice/management"
                },
                {
                    title: "Break Room",
                    uri: "/advice/break-room"
                }
            ]
        },
        {
            title: "Diversity and Inclusion",
            uri: "/advice/diversity-inclusion",
            children: [
                {
                    title: "Anti-Racism at Work",
                    uri: "/advice/anti-racism-at-work"
                },
                {
                    title: "LGBTQ at Work",
                    uri: "/advice/lgbtq-at-work"
                },
                {
                    title: "Disability and Work",
                    uri: "/advice/disability-and-work"
                },
                {
                    title: "Gender and Work",
                    uri: "/advice/gender-and-work"
                }
            ]
        },
        {
            title: "More",
            uri: "",
            children: [
                {
                    title: "Videos",
                    uri: "/advice/videos",
                    children: [
                        {
                            title: "Job Search Videos",
                            uri: "/advice/job-search-videos"
                        },
                        {
                            title: "Career Advice Videos",
                            uri: "/advice/career-advice-videos"
                        },
                        {
                            title: "Career Story Videos",
                            uri: "/advice/career-story-videos"
                        },
                        {
                            title: "Company Spotlight Videos",
                            uri: "/advice/company-spotlight-videos"
                        },
                        {
                            title: "Industry Spotlight Videos",
                            uri: "/advice/industry-spotlight-videos"
                        }
                    ]
                },
                {
                    title: "Employer Resources",
                    uri: "/advice/employer-resources"
                }
            ]
        }
    ]
};

// EXTERNAL MODULE: ./src/components/subNav.module.scss
var subNav_module = __webpack_require__(8621);
var subNav_module_default = /*#__PURE__*/__webpack_require__.n(subNav_module);
;// CONCATENATED MODULE: ./src/components/SubNav.tsx

/* eslint no-use-before-define: ["error", { "variables": false }] */ 



/**
 * Is the current elements title contained within the breadcrumb list.
 */ const isActive = (breadCrumbs = [], title)=>{
    const str = breadCrumbs?.some((crumb)=>crumb?.title?.toLowerCase() === title?.toLowerCase()) ? (subNav_module_default()).subNavActive : "";
    return str;
};
const getLinkOrText = (title, uri, activeClass)=>{
    const textClass = `${(subNav_module_default()).linkText} ${activeClass}`;
    if (uri) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (subNav_module_default()).navLink,
            href: uri,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: textClass,
                children: title
            })
        });
    }
    // adding tabIndex here so that this item can gain focus.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (subNav_module_default()).navLink,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: textClass,
            children: title
        })
    });
};
/**
 * Gets the list of fly-out elements.
 */ const getChildren = (items, breadCrumbs = [], isGrandChild)=>{
    const children = items.length ? items.map((item)=>getChild(item, breadCrumbs, isGrandChild)) : null;
    return children;
};
/**
 * Renders the top level nav items.
 */ const getTopMenu = (items = [], breadCrumbs = [])=>items.map((item)=>{
        const { uri , title , children  } = item;
        const activeClass = isActive(breadCrumbs, title);
        const allLink = uri ? getLinkOrText(`View all in ${title} >`, uri, "") : null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            role: "menuitem",
            className: (subNav_module_default()).menuItem,
            tabIndex: 0,
            children: [
                getLinkOrText(title, "", activeClass),
                children && children.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    role: "menu",
                    className: (subNav_module_default()).menuGroup,
                    children: [
                        getChildren(children, breadCrumbs),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (subNav_module_default()).menuTitle,
                            children: allLink
                        })
                    ]
                }) : null
            ]
        }, title);
    });
/**
 * Renders the fly-outs
 */ const getChild = (item, breadCrumbs = [], isGrandChild)=>{
    const { uri , title , children  } = item;
    const activeClass = isActive(breadCrumbs, title);
    const nestedClass = isGrandChild ? (subNav_module_default()).menuItemNested : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                role: "menuitem",
                className: nestedClass,
                children: getLinkOrText(title, uri, activeClass)
            }),
            children && children.length ? getChildren(children, breadCrumbs, true) : null
        ]
    }, title);
};
/**
 * Renders a SubNav module
 */ const SubNav = ()=>{
    const { article , pageMetaData: { pathName  }  } = (0,AppContext/* useAppState */.mr)();
    const breadCrumbs = article?.breadcrumbLinks;
    const crumb = article?.breadcrumbLink || undefined;
    const { items  } = subNavItems;
    const page = {
        title: article?.title || "",
        uri: pathName
    };
    if (crumb) {
        breadCrumbs.push(crumb);
    }
    // the page should always be last.
    breadCrumbs.push(page);
    return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        role: "menubar",
        className: (subNav_module_default()).subNav,
        "aria-label": "Sub Navigation",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            role: "menu",
            className: (subNav_module_default()).menu,
            children: getTopMenu(items, breadCrumbs)
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/html-react-parser/esm/index.mjs
var esm = __webpack_require__(7311);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/SEO.tsx

/* eslint-disable max-len */ 




const organization = {
    "@type": "Organization",
    description: "The Muse is the go-to destination for people to research everything they need to know about companies and careers.",
    logo: {
        "@type": "ImageObject",
        url: "https://assets.themuse.com/uploaded/companies/1327/small_logo.png?v=1664489768",
        description: "The Muse",
        width: 668,
        height: 296
    },
    legalName: "Daily Muse Inc.",
    name: "The Muse",
    sameAs: [
        "https://www.facebook.com/thedailymuse",
        "https://twitter.com/TheMuse",
        "https://www.instagram.com/themuse/",
        "https://www.youtube.com/channel/UCk4bbQAZD26f_XdGyb4wwhg",
        "https://www.linkedin.com/company/the-daily-muse/",
        "https://en.wikipedia.org/wiki/The_Muse_(website)",
        "https://www.pinterest.com/thedailymuse/",
        "https://www.tiktok.com/@themuse_",
        "https://www.threads.net/@themuse"
    ],
    url: "https://www.themuse.com",
    address: {
        "@type": "PostalAddress",
        streetAddress: "1375 Broadway, 20th Floor",
        addressLocality: "New York",
        addressRegion: "NY",
        postalCode: 10018,
        addressCountry: "US"
    }
};
/**
 * Generates the open graph object.
 * @returns an Object
 */ const genOpenGraphJSON = (props)=>{
    const { author , canonical , description , leadMediaAlt , leadMediaHeight , leadMediaUrl , leadMediaWidth , modifiedTime , postDate , title ,  } = props;
    return {
        title,
        description,
        url: canonical,
        type: "article",
        site_name: "The Muse",
        locale: "en_US",
        article: {
            publishedTime: postDate,
            modifiedTime,
            authors: [
                author
            ]
        },
        images: [
            {
                alt: leadMediaAlt,
                url: leadMediaUrl,
                width: leadMediaWidth,
                height: leadMediaHeight
            }
        ]
    };
};
/**
 * Generates the Twitter object passed into NextSEO.
 * @returns an Object
 */ const genTwitterJSON = ()=>({
        handle: "@TheMuse",
        site: "@TheMuse",
        cardType: "summary_large_image"
    });
/**
 * Generates the article schema object passed into LD+Json.
 * @returns an Object
 */ const genArticleJSON = (props)=>{
    const { canonical , description , leadMediaUrl , modifiedTime , postDate , title , writerName , author ,  } = props;
    return {
        "@context": "https://schema.org",
        "@type": "Article",
        datePublished: postDate,
        description,
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": `${canonical}`
        },
        headline: title,
        image: {
            "@type": "ImageObject",
            url: leadMediaUrl,
            width: 820,
            height: 430
        },
        dateModified: modifiedTime,
        author: [
            {
                "@type": "Person",
                name: writerName,
                url: author
            }
        ],
        publisher: organization
    };
};
/**
 * Generates the breadcrumb schema object passed into LD+Json.
 * @returns an Object
 */ const genBreadcrumbJSON = (breadcrumbLinks)=>{
    const cleanCrumbs = breadcrumbLinks.filter((x)=>x.title && x.uri);
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: cleanCrumbs.map((x, i)=>({
                "@type": "ListItem",
                position: i + 1,
                item: {
                    "@id": `https://www.themuse.com/${x.uri}`,
                    name: /^advice$/i.test(x.title) ? "Advice" : x.title
                }
            }))
    };
};
/**
 * Generates the organization schema object passed into LD+Json.
 * @returns an Object
 */ const genOrganizationJSON = ()=>({
        "@context": "https://schema.org",
        ...organization
    });
/**
 * Generates the SEO data for the head both LD+JSON and MetaData links.
 * @returns React.ReactElement
 */ const SEO = (props)=>{
    const { publicRuntimeConfig: { museHost  }  } = (0,config["default"])();
    const { canonical , breadcrumbLinks , dateUpdated , description , leadMedia , postDate , primaryTopic , seo , title , writerName , writerUri ,  } = props;
    const { altText , url ,  } = leadMedia || {};
    const modifiedTime = postDate > dateUpdated ? postDate : dateUpdated;
    const author = `${museHost}/${writerUri}`;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonical
                    }, "canonical"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }, "robots"),
                    (0,esm/* default */.ZP)(seo.MetaTitleContainer),
                    (0,esm/* default */.ZP)(seo.MetaTagContainer),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: altText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:author",
                        content: author
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:modified_time",
                        content: modifiedTime
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:published_time",
                        content: postDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:section",
                        content: "Advice"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:tag",
                        content: primaryTopic.title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "Article-JSON",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(genArticleJSON({
                        canonical,
                        description,
                        leadMediaUrl: url,
                        modifiedTime,
                        postDate,
                        title,
                        writerName,
                        author
                    }))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "BreadcrumbList-JSON",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(genBreadcrumbJSON(breadcrumbLinks))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "Organization-JSON",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(genOrganizationJSON())
                }
            })
        ]
    });
};
// WARNING: These are for unit testing only and should NEVER be used directly outside this file.
const openGraphJSONTestingOnly = (/* unused pure expression or super */ null && (genOpenGraphJSON));
const twitterJSONTestingOnly = (/* unused pure expression or super */ null && (genTwitterJSON));
const articleJSONTestingOnly = (/* unused pure expression or super */ null && (genArticleJSON));
const breadcrumbJSONTestingOnly = (/* unused pure expression or super */ null && (genBreadcrumbJSON));
const organizationJSONTestingOnly = (/* unused pure expression or super */ null && (genOrganizationJSON));


// EXTERNAL MODULE: ./src/utils/errors.ts
var errors = __webpack_require__(3197);
// EXTERNAL MODULE: ./src/Homepage/MediaVine.tsx
var MediaVine = __webpack_require__(4301);
// EXTERNAL MODULE: ./src/styles/Home.module.scss
var Home_module = __webpack_require__(4865);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./src/components/MayaBanner/MayaBanner.module.scss
var MayaBanner_module = __webpack_require__(8419);
var MayaBanner_module_default = /*#__PURE__*/__webpack_require__.n(MayaBanner_module);
;// CONCATENATED MODULE: ./src/components/MayaBanner/MayaBanner.tsx




const MayaBanner = ()=>{
    const { FEATURE_FLAG_ARTICLE_MAYA_BANNER  } = (0,FeatureFlagsContext/* useFeatureFlagsState */.n)();
    if (!FEATURE_FLAG_ARTICLE_MAYA_BANNER) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        className: (MayaBanner_module_default()).mayaPromo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (MayaBanner_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (MayaBanner_module_default()).msgWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://www.themuse.com/maya",
                            className: (MayaBanner_module_default()).adviceIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 71 56",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fill: "#EAF6FA",
                                        d: "M19.717 47.665c.854-.183 1.77-.58 1.77-2.654v-6.894c0-1.891-1.19-2.684-2.563-2.684-.824 0-1.647.335-2.44 1.006.06.336.091.702.091 1.068v7.504c0 2.074.885 2.47 1.77 2.654v.457h-7.84v-.457c.884-.183 1.769-.58 1.769-2.654v-6.894c0-1.922-1.16-2.684-2.562-2.684-.824 0-1.617.335-2.35.976v8.602c0 2.074.916 2.47 1.8 2.654v.457H.896v-.457c1.037-.183 2.135-.58 2.135-2.654V35.86c0-2.075-1.098-2.471-2.135-2.654v-.458h6.467v2.837c1.037-1.739 2.593-3.02 4.758-3.02 2.044 0 3.691 1.098 4.271 3.264 1.037-1.86 2.654-3.264 4.88-3.264 2.502 0 4.515 1.678 4.515 4.942v7.504c0 2.074 1.129 2.47 2.105 2.654v.457h-8.175v-.457Zm12.329.732c-2.502 0-4.393-1.77-4.393-4.21 0-3.294 3.295-5.43 8.389-4.545v-1.83c0-2.074-1.526-2.99-3.203-2.99-1.373 0-3.02.58-4.27 2.44l-.458-.121c.67-2.288 2.928-4.515 6.375-4.576 3.539-.06 5.918 2.197 5.918 5.125v6.985c0 .763.122 1.465.671 1.465.091 0 .305-.03.457-.092l.214.183c-.427 1.068-1.495 2.166-3.05 2.166-1.434 0-2.41-.915-2.624-2.135-.823 1.159-2.166 2.135-4.026 2.135Zm-.305-4.759c0 1.465.67 2.807 2.166 2.807.884 0 1.647-.519 2.135-1.16v-4.82c-2.654-.274-4.301.977-4.301 3.173Zm9.33 10.036.55-3.325.396-.244c2.654 1.648 5.247 1.007 5.949-.732l.06-.183-5.52-13.513c-.794-1.953-1.648-2.288-2.35-2.471v-.458h8.237v.458c-1.16.244-1.922.701-1.22 2.501l3.111 7.9 3.173-7.93c.762-1.861-.305-2.288-1.434-2.471v-.458h5.247v.458c-.793.183-1.8.549-2.563 2.47l-5.826 14.216c-1.77 4.331-4.24 5.551-7.81 3.782Zm19.394-5.277c-2.502 0-4.393-1.77-4.393-4.21 0-3.294 3.295-5.43 8.389-4.545v-1.83c0-2.074-1.525-2.99-3.203-2.99-1.373 0-3.02.58-4.27 2.44l-.458-.121c.67-2.288 2.928-4.515 6.375-4.576 3.539-.06 5.918 2.197 5.918 5.125v6.985c0 .763.122 1.465.671 1.465.092 0 .305-.03.458-.092l.213.183c-.427 1.068-1.495 2.166-3.05 2.166-1.434 0-2.41-.915-2.624-2.135-.823 1.159-2.166 2.135-4.026 2.135Zm-.305-4.759c0 1.465.67 2.807 2.166 2.807.884 0 1.647-.519 2.135-1.16v-4.82c-2.654-.274-4.301.977-4.301 3.173Z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fill: "#fff",
                                        d: "M32.853 15.475V10.32h-1.188v-.271a5.986 5.986 0 0 0 3.226-2.752h.34V9.71h2.208v.611H35.23v4.96c0 .85.342 1.495 1.053 1.495a1.56 1.56 0 0 0 1.055-.442l.204.068c-.442.917-1.191 1.73-2.48 1.73-1.395-.083-2.209-1.027-2.209-2.656Z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fill: "#fff",
                                        d: "M38.459 16.213V7.892c0-1.12-.613-1.223-1.191-1.223l-.033-.236 3.566-.61v5.331a2.849 2.849 0 0 1 2.548-1.563c1.326 0 2.583.885 2.583 2.651v4.008c0 1.12.61 1.324 1.12 1.427v.236h-4.45v-.236c.443-.103.95-.307.95-1.427v-3.704c0-1.053-.61-1.46-1.289-1.495a2.171 2.171 0 0 0-1.462.578v4.585c0 1.121.542 1.325 1.052 1.428v.239h-4.555v-.234c.542-.108 1.161-.312 1.161-1.433Zm8.526-2.412c0-2.648 1.563-4.21 3.872-4.21 2.547 0 3.633 1.969 3.6 4.007H49.43c.103 2.208 1.189 3.16 2.442 3.16a3.16 3.16 0 0 0 2.345-1.19l.203.035a3.742 3.742 0 0 1-3.497 2.442c-1.9.003-3.937-1.39-3.937-4.244Zm5.155-.71c0-1.26-.342-2.985-1.292-2.985s-1.356 1.834-1.392 2.984h2.684Zm-9.505 12.397v-3.704c0-1.017-.643-1.424-1.357-1.424-.485.005-.948.2-1.291.542.028.191.039.385.032.578v4.008c0 1.12.478 1.324.953 1.427v.236h-4.179v-.236c.475-.103.952-.306.952-1.427v-3.669c0-1.02-.613-1.427-1.356-1.427a1.9 1.9 0 0 0-1.262.51v4.586c0 1.12.475 1.324.95 1.427v.236h-4.415v-.236c.578-.103 1.153-.306 1.153-1.427V20.63c0-1.12-.575-1.327-1.153-1.395v-.233h3.465v1.527c.578-.917 1.392-1.595 2.548-1.595a2.23 2.23 0 0 1 2.274 1.731c.578-.985 1.394-1.731 2.615-1.731 1.327 0 2.413.882 2.413 2.648v4.008c0 1.123.613 1.327 1.12 1.427v.239h-4.341v-.239c.404-.206.879-.418.879-1.53Zm3.5-.885v-4.007c0-1.121-.613-1.325-1.156-1.392v-.24h3.5V24.3c0 1.053.611 1.46 1.29 1.495a2.257 2.257 0 0 0 1.495-.613v-4.55c0-1.12-.51-1.327-.95-1.395v-.233h3.327v6.555c0 1.121.613 1.325 1.123 1.428v.236H51.95a3.99 3.99 0 0 1-.646-1.392 3.21 3.21 0 0 1-2.615 1.495c-1.33-.07-2.554-.955-2.554-2.722Zm8.933 2.041v-2.38h.271c.953 1.938 1.87 2.515 2.822 2.515.814 0 1.221-.442 1.221-1.052 0-.988-1.12-1.26-2.344-1.802-1.46-.646-2.171-1.392-2.171-2.513 0-1.495 1.189-2.547 3.194-2.547a7.97 7.97 0 0 1 2.713.577v2.206h-.271c-.746-1.866-1.628-2.24-2.413-2.24-.846 0-1.356.441-1.356 1.02 0 .849 1.188 1.085 2.683 1.834.882.371 1.867.95 1.867 2.377 0 1.698-1.289 2.648-3.123 2.648a8.01 8.01 0 0 1-3.093-.643Zm6.922-3.571c0-2.648 1.563-4.211 3.872-4.211 2.515 0 3.636 1.97 3.6 4.008h-5.03c.103 2.208 1.19 3.158 2.442 3.158a3.156 3.156 0 0 0 2.344-1.189l.204.036a3.747 3.747 0 0 1-3.5 2.442c-1.919.005-3.932-1.387-3.932-4.244Zm5.128-.714c0-1.256-.34-2.984-1.289-2.984-.95 0-1.357 1.837-1.394 2.984h2.683Z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fill: "#9ADBF5",
                                        d: "M14.86 19.948v-.225A14.103 14.103 0 0 0 2.026 5.667 1.18 1.18 0 0 0 .737 6.72v19.284a1.203 1.203 0 0 0 1.188 1.187H14.86v-7.242Z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fill: "#fff",
                                        d: "M14.86 19.948v-.225A14.103 14.103 0 0 1 27.691 5.667a1.191 1.191 0 0 1 1.29 1.124v19.25a1.2 1.2 0 0 1-1.187 1.187H14.86v-7.28Z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fill: "#9ADBF5",
                                        d: "m27.96 3.952.837-.251a1.817 1.817 0 0 0 1.214-1.214l.252-.837c.05-.167.29-.167.34 0l.252.837A1.817 1.817 0 0 0 32.068 3.7l.837.251c.167.05.167.29 0 .34l-.837.252a1.817 1.817 0 0 0-1.213 1.214l-.252.836c-.05.168-.29.168-.34 0l-.252-.836a1.817 1.817 0 0 0-1.213-1.214l-.837-.252c-.168-.05-.168-.29 0-.34Zm-2.916-1.499.425-.129c.407-.122.723-.44.847-.846l.128-.426c.044-.146.25-.146.296 0l.128.426c.122.406.44.723.847.846l.426.129c.146.043.146.25 0 .295l-.426.129c-.406.122-.723.44-.847.846l-.128.426c-.044.146-.25.146-.296 0l-.128-.426a1.266 1.266 0 0 0-.847-.846l-.425-.129c-.146-.044-.146-.25 0-.295Z"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Need AI-powered career advice, guidance, support?"
                                }),
                                " Ask Maya from The Muse."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MayaBanner_module_default()).btnWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.themuse.com/maya",
                        className: (MayaBanner_module_default()).cta,
                        children: "Get started"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/index.tsx






















/**
 * Asynchronously fetches Carmen location data and updates the user location state.
 *
 * @param setUserLocation - A function to update the user location state with the fetched Carmen data.
 *
 * Fetches data using `fetchApiCarmenData` and, if successful, sets the user location
 * with the JSON stringified response. Logs an error message if the fetch fails.
 */ const setUserCarmenData = async (setUserLocation)=>{
    try {
        const carmenResponse = await (0,api/* fetchApiCarmenData */.$3)();
        if (carmenResponse) {
            setUserLocation(JSON.stringify(carmenResponse));
        }
    } catch (error) {
        const msg = (0,errors/* getFetchError */.c)("Carmen Location", "Front-End");
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
    }
};
/**
 * Asynchronously sets the user data in the application state.
 *
 * Fetches user information from the API and updates the application state
 * with the user's location and login status. If an error occurs during the
 * fetch operation, logs the error with a formatted message.
 *
 * @param {string | null} userLocation - The user's location in JSON string format.
 * @param {Function} dispatch - The dispatch function to update the application state.
 */ const setUser = async (userLocation, dispatch)=>{
    try {
        const apiUser = await (0,api/* fetchUser */.BT)();
        const userData = userLocation ? {
            location: JSON.parse(userLocation)
        } : {};
        dispatch({
            type: appContextInterfaces/* UserActionTypes.updateUser */.F6.updateUser,
            payload: {
                ...apiUser?.logged_in && apiUser,
                ...userData,
                isInitialized: true
            }
        });
    } catch (error) {
        const msg = (0,errors/* getFetchError */.c)("User", "Front-End");
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
    }
};
/**
 * UserInit is a React functional component that initializes user-related data
 * and manages user location state using session storage. It dispatches user
 * updates to the application state and sets user Carmen data on component mount.
 *
 * @param {React.PropsWithChildren<{}>} props - The component's children elements.
 * @returns {JSX.Element} The rendered children elements.
 *
 * @remarks
 * - Utilizes `useAppState` to access the current user state.
 * - Uses `useSessionStorage` to persist user location across sessions.
 * - Dispatches user updates using `useAppDispatch`.
 * - Employs `useEffect` hooks to handle side effects related to user location
 *   and Carmen data initialization.
 */ const UserInit = ({ children  })=>{
    const { user  } = (0,AppContext/* useAppState */.mr)();
    const [userLocation, setUserLocation] = (0,useSessionStorage/* default */.Z)("user_location");
    const appDispatch = (0,AppContext/* useAppDispatch */.TL)();
    react.useEffect(()=>{
        setUser(userLocation, appDispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userLocation
    ]);
    react.useEffect(()=>{
        setUserCarmenData(setUserLocation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    react.useEffect(()=>{
        appDispatch({
            type: appContextInterfaces/* UserActionTypes.updateUser */.F6.updateUser,
            payload: {
                ...user,
                location: userLocation ? JSON.parse(userLocation) : user?.location
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userLocation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/**
 * PageMetaInit is a React functional component that initializes and updates
 * the page metadata in the application state using the current window location
 * and document referrer. It dispatches an action to update the page metadata
 * when the component mounts.
 *
 * @param {React.PropsWithChildren<{}>} props - The component's children.
 * @returns {JSX.Element} The rendered children components.
 */ const PageMetaInit = ({ children  })=>{
    const { pageMetaData  } = (0,AppContext/* useAppState */.mr)();
    const appDispatch = (0,AppContext/* useAppDispatch */.TL)();
    react.useEffect(()=>{
        const { href , search  } = window.location;
        const { referrer  } = document;
        appDispatch({
            type: appContextInterfaces/* PageMetaDataActionTypes.updatePageMetaData */.e9.updatePageMetaData,
            payload: {
                ...pageMetaData,
                ...{
                    href,
                    search,
                    referrer
                }
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/**
 * Handles server-side logic for fetching initial application parameters and managing redirects.
 *
 * @param {GetServerSidePropsContext} context - The context object containing request details.
 * @returns {Promise<{ redirect?: { destination: string, permanent: boolean }, notFound?: boolean, props?: InitialAppParams }>}
 * - Returns a redirect object for malformed URLs or CMS redirects, a notFound flag for non-existent articles,
 *   or props containing initial application parameters and feature flags.
 *
 * The function checks for malformed URLs and redirects them permanently to the correct page.
 * It also handles 404 errors for non-existent articles and processes CMS redirects.
 * If the article is found, it returns the initial application parameters and active feature flags.
 */ const SnowPlowInit = ()=>{
    const { publicRuntimeConfig: { snowplowCollector  }  } = (0,config["default"])();
    const { user , article: { sponsor , id: articleId  }  } = (0,AppContext/* useAppState */.mr)();
    const { 0: pageViewed , 1: setPageViewed  } = (0,react.useState)(false);
    const { legacyId: companySponsorId  } = sponsor;
    const pageData = (0,react.useMemo)(()=>({
            sp_page_is_external: false,
            sp_page_section: "advice",
            sp_page_sponsor_id: companySponsorId?.toString() || null,
            sp_page_tab: null,
            sp_page_type: "content",
            sp_page_entity_id: articleId.toString() || null,
            sp_page_entity_uuid: null,
            sp_user_logged_in: user?.logged_in,
            sp_user_id: user?.id,
            sp_experiment_experiment_id: "",
            sp_experiment_variant_id: ""
        }), []);
    react.useEffect(()=>{
        if (!pageViewed) {
            // eslint-disable-next-line no-underscore-dangle
            const enabledVariant = (0,experiment_client_build.getActiveVariant)("XXXXX", window.__NEXT_DATA__.props.pageProps.experiments);
            const experimentData = enabledVariant ? {
                sp_experiment_experiment_id: "XXXXX",
                sp_experiment_variant_id: enabledVariant
            } : {};
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ...pageData,
                ...experimentData
            });
            (0,build.initSnowplowTracker)(snowplowCollector);
            (0,build.trackSnowplowImpressions)();
            (0,build.trackSnowplowClicks)();
            (0,build.trackSnowplowModalActions)();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    react.useEffect(()=>{
        if (user.isInitialized && !pageViewed) {
            (0,build.triggerSnowplowPageViewEvent)();
            setPageViewed(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user
    ]);
    return null;
};
var __N_SSP = true;
/**
 * Formats an array of company suggestions by mapping each suggestion to an object
 * containing a label and a value. The label is derived from the suggestion's text,
 * and the value is a URL path constructed using the suggestion's short_name.
 * Only the first four suggestions are processed.
 *
 * @param {CompanySuggestion[]} companySuggestions - The array of company suggestions to format.
 * @returns {Array<{ label: string, value: string }>} An array of formatted company suggestion objects.
 */ const formatCompanySuggestions = (companySuggestions)=>companySuggestions.slice(0, 4).map((companyResult)=>{
        const { text , value  } = companyResult;
        const { short_name  } = value; // eslint-disable-line camelcase
        return {
            label: `${text}`,
            value: `/profiles/${short_name}` // eslint-disable-line camelcase
        };
    });
/**
 * Updates the input value and fetches company suggestions based on the input.
 *
 * @param changes - The state changes from the combobox, including the new input value.
 * @param setItems - Function to update the list of items displayed in the combobox.
 * @param setInputValue - Function to update the current input value in the combobox.
 * @param fetchData - Asynchronous function to fetch company suggestions based on the input value.
 *
 * The function sets the input value and updates the items in the combobox.
 * If the input value is not empty, it fetches company suggestions and updates the items list.
 * If the input value is empty, it clears the items list.
 */ const updateInput = async (changes, setItems, setInputValue, fetchData)=>{
    const { inputValue  } = changes;
    const jobSearchItem = {
        label: `${inputValue}`,
        value: `/search/keyword/${inputValue}/`
    };
    setInputValue(inputValue);
    if (inputValue) {
        setItems([
            jobSearchItem
        ]);
        const companyResults = await fetchData(inputValue);
        const companyList = companyResults?.length ? formatCompanySuggestions(companyResults) : [];
        setItems([
            jobSearchItem
        ].concat(companyList));
    } else {
        setItems([]);
    }
};
/**
 * Renders the ArticlePage component, which displays an article with its metadata,
 * search functionality, and advertisements based on certain conditions.
 *
 * @param props - The server-side props containing article data, feature flags,
 * experiments, and the current path.
 * @returns A JSX element representing the article page layout with various
 * components such as SEO, MediaVine ads, and article content.
 */ const ArticlePage = (props)=>{
    const { article , featureFlags , experiments , path  } = props;
    const { articleUri , contentAuthor , breadcrumbLinks , dateUpdated , excerpt , leadMedia , postDate , primaryTopic , seo , sponsor , product , title , tags  } = article;
    const { writerName , writerUri ,  } = contentAuthor ?? {};
    const canonical = (0,strings/* getCanonicalUrl */.Z2)(path);
    const description = excerpt;
    const pageMetaData = {
        pathName: path
    };
    const { 0: dropdownItems , 1: setDropdownItems  } = (0,react.useState)([]);
    const { 0: inputValue , 1: setInputValue  } = (0,react.useState)("");
    const searchQuerySubmittedEvent = (selectedItemText)=>{
        const searchTerm = selectedItemText || inputValue;
        const eventProps = {
            search_term: searchTerm || ""
        };
        (0,tracking/* pushDataLayerEvent */.Jt)("searchQuerySubmitted", eventProps);
    };
    const onKeyboardSelectItem = (_, selectedItem)=>{
        if (!(0,browser/* isBrowser */.jU)()) return "";
        const searchPath = inputValue ? `/search/keyword/${inputValue}` : "/search";
        const selectPath = selectedItem?.value ? selectedItem?.value : searchPath;
        searchQuerySubmittedEvent(selectedItem?.label);
        return window.open(selectPath, "_blank").focus();
    };
    const onMouseSelectItem = (_, selectedItem)=>{
        searchQuerySubmittedEvent(selectedItem.label);
    };
    const dropdownProps = {
        IconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {}),
        debounceWait: 10,
        dropdownList: dropdownItems,
        inputId: "search-input",
        onInputChange: (changes)=>updateInput(changes, setDropdownItems, setInputValue, api/* fetchCompanySuggestions */.SC),
        noResultsMessage: " ",
        onKeyboardSelectItem,
        onMouseSelectItem
    };
    const pageLayoutProps = {
        activePath: "/advice",
        headerClassName: (Home_module_default()).pageHeader,
        pageName: (Home_module_default()).pageWrapper,
        mainClassName: (Home_module_default()).main,
        enableCompanySearch: true,
        companySearchDropdownProps: dropdownProps,
        showSubMenus: true
    };
    // A list of allowed ad types om the article pages.
    const allowedAds = [
        "adhesion-mobile",
        "adhesion-tablet",
        "adhesion-desktop",
        "content-desktop",
        "content-mobile",
        "in-image",
        "interstitial-mobile",
        "interstitial-desktop",
        "leaderboard",
        "sidebar-atf",
        "sidebar-btf",
        "universal-player-desktop",
        "universal-player-mobile"
    ];
    /**
     * To have ads you must:
     * * Not be a roundup
     * * Not be tagged as vibe-awards
     * * Not be sponsored.
     */ const hasAds = !/roundup/.test(product?.slug ?? false) && !sponsor?.hasSponsorShip && !tags.filter((x)=>x?.slug?.includes("vibe-awards"))?.length;
    const allowList = hasAds ? allowedAds : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(experiment_client_build.ExperimentProvider, {
        experiments: experiments,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext/* FeatureFlagsProvider */.O, {
            featureFlags: featureFlags,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppContext/* AppProvider */.wI, {
                article,
                pageMetaData,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaVine/* MediaVine */.U, {
                        allowList
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO, {
                        articleUri,
                        canonical,
                        breadcrumbLinks,
                        dateUpdated,
                        description,
                        leadMedia,
                        postDate,
                        primaryTopic,
                        seo,
                        title,
                        writerName,
                        writerUri
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInit, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMetaInit, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SnowPlowInit, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppPageLayout/* AppPageLayout */.a, {
                                    ...pageLayoutProps,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MayaBanner, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNav, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleContainer, {})
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var pages = (ArticlePage);


/***/ }),

/***/ 8765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getObserver; }
/* harmony export */ });
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6337);
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(intersection_observer__WEBPACK_IMPORTED_MODULE_0__);

/**
 * Creates an intersection observer.
 * At minimum you need a callback function to fire on each element as it enters the viewport.
 * You can pass in optional object with threshold and margin.
 */ const getObserver = (cb, options)=>{
    const OBSERVER_OPTIONS = {
        rootMargin: "0px",
        threshold: 1.0,
        ...options
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const element = entry.target;
                if (!entry.isIntersecting || !(element instanceof HTMLElement)) {
                    return;
                }
                cb(element);
                observer.unobserve(element);
            }
        }, OBSERVER_OPTIONS);
    });
    return observer;
};


/***/ }),

/***/ 2918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z2": function() { return /* binding */ getCanonicalUrl; },
/* harmony export */   "zv": function() { return /* binding */ getId; }
/* harmony export */ });
/* unused harmony exports formatNumberComma, objToQueryString, queryStringToObj, isTruthy, titleCase, normalizeAccents, parsePath, objToQueryParams, slugify, formatDate, camelToSnakeCase */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3135);

/**
 * Convert a word to proper Case.
 */ const titleWordCase = (txt)=>`${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`;
/**
 * Convert a sentence to proper Case.
 */ const titleCase = (txt)=>txt.split(" ").map(titleWordCase).join(" ");
/**
 * Converts a diacritic to normalized character plus accent. Then removes the accent.
 */ const normalizeAccents = (txt)=>txt.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
/**
 * Convert number to string and add a comma for thousands and millions.
 */ const formatNumberComma = (value)=>new Intl.NumberFormat("en-US").format(value);
/**
 * generate the canonical URL.
 */ const getCanonicalUrl = (asPath = "/")=>{
    const preface = "https://www.themuse.com";
    const path = asPath.split("?")[0];
    return preface + path;
};
/**
 * Returns true for "true", "True", "TRUE" and "1".
 * @param string string
 * @returns boolean
 */ const isTruthy = (string)=>/^(true|1)$/.test(string.toLowerCase());
const parsePath = (urlPath)=>urlPath.replace(/^\/(search\/)?/, "").split("/").reduce((values, pathPart, index, shortenedPath)=>{
        const localValues = values;
        if (index % 2) {
            localValues[shortenedPath[index - 1]] = pathPart;
        } else {
            localValues[pathPart] = "";
        }
        return localValues;
    }, {});
/**
 *  Rename the object names to query param names
 */ const objToQueryParams = (obj)=>{
    const mappedObj = Object.keys(obj).reduce((acc, key)=>({
            ...acc,
            ...{
                [key]: encodeURIComponent(obj[key])
            }
        }), {});
    const queryParamStr = Object.keys(mappedObj).filter((key)=>{
        if (mappedObj[key] && mappedObj[key].length > 0) {
            return key;
        }
        return null;
    }).map((key)=>`${key}/${mappedObj[key] || ""}`).join("/");
    return queryParamStr;
};
/**
 * Convert the query string into an object
 */ const queryStringToObj = (searchString)=>{
    const pairs = searchString.split("&");
    const result = {};
    pairs.forEach((pair)=>{
        const pairSplit = pair.split("=");
        if (pairSplit[0] in result) {
            // check for additional values and add it to the result[key]
            const splitValues = result[pairSplit[0]].split(",");
            splitValues.push(decodeURIComponent(pairSplit[1]));
            result[pairSplit[0]] = splitValues.join(",");
        } else {
            result[pairSplit[0]] = decodeURIComponent(pairSplit[1] || "");
        }
    });
    return result;
};
/**
 * Convert an object to query string removing nulls.
 */ const objToQueryString = (obj)=>Object.keys(obj).map((key)=>`${key}=${obj[key] || ""}`).join("&");
/**
 * Remove special characters and reduce to lower case with hyphens.
 */ const slugify = (text)=>decodeURIComponent(text).replace(/[^a-z0-9]/gmi, "-").replace(/--/gmi, "-").toLowerCase();
/**
 * Formats a date in correct format for job card
 */ const formatDate = (date)=>{
    const month = months[date.getMonth()];
    const day = date.getDate();
    return `${month} ${day}`;
};
function camelToSnakeCase(text) {
    return text.replace(/(.)([A-Z][a-z]+)/, "$1_$2").replace(/([a-z0-9])([A-Z])/, "$1_$2").toLowerCase();
}
/**
 * Converts an id number to a string
 */ const getId = (id)=>id ? parseInt(id, 10) : undefined;



/***/ }),

/***/ 6614:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JobQuizContainer_container__VsE1B","gallery":"JobQuizContainer_gallery__gt7uE","viewer":"JobQuizContainer_viewer__56c84","navigation":"JobQuizContainer_navigation__QESW4","navButtons":"JobQuizContainer_navButtons__kvexM","spacer":"JobQuizContainer_spacer___g_eT","prevButton":"JobQuizContainer_prevButton__9meg7","nextButton":"JobQuizContainer_nextButton__540QW","navRight":"JobQuizContainer_navRight__k7zzK","progressBar":"JobQuizContainer_progressBar__Jdlcc","progressState":"JobQuizContainer_progressState__8jFFx","brandMark":"JobQuizContainer_brandMark__pLdt8","curvedLine":"JobQuizContainer_curvedLine__6yC4e","buttonGroup":"JobQuizContainer_buttonGroup__shvmq","buttonGroup__item":"JobQuizContainer_buttonGroup__item__NNeT9","inputTitle":"JobQuizContainer_inputTitle__OpWsB","multiSelectItem":"JobQuizContainer_multiSelectItem__7PR_3","buttonGroup__flow":"JobQuizContainer_buttonGroup__flow__y5oUH","contentBody":"JobQuizContainer_contentBody__S79QU","title":"JobQuizContainer_title__bkfPs","center":"JobQuizContainer_center__E71ld","details":"JobQuizContainer_details__BeHz4","inputs":"JobQuizContainer_inputs__V_m56","loadingBody":"JobQuizContainer_loadingBody__t16cY","loadingGif":"JobQuizContainer_loadingGif__3z7b5","imageBubble_1":"JobQuizContainer_imageBubble_1__EBLtq","imageBubble_2":"JobQuizContainer_imageBubble_2__8WsmL","imageBubble_3":"JobQuizContainer_imageBubble_3__bzSj1","primaryCta":"JobQuizContainer_primaryCta__ZH7Ax","secondaryCta":"JobQuizContainer_secondaryCta__Hlpfm"};

/***/ }),

/***/ 8419:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mayaPromo":"MayaBanner_mayaPromo__NFRfc","contentWrapper":"MayaBanner_contentWrapper__7x8_g","msgWrapper":"MayaBanner_msgWrapper__YkUMG","btnWrapper":"MayaBanner_btnWrapper__TqhRM","adviceIcon":"MayaBanner_adviceIcon__S7u_p"};

/***/ }),

/***/ 4847:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article":"articleContainer_article__sZv8h","articleContainer":"articleContainer_articleContainer__6hkG4","articleBody":"articleContainer_articleBody__Th07G","lastUpdatedDisplay":"articleContainer_lastUpdatedDisplay__XisTK","articleBodyWrapper":"articleContainer_articleBodyWrapper__T0lH7","articlePostBodyWrapper":"articleContainer_articlePostBodyWrapper__dZ_QB","articleContentNewsletterWrapper":"articleContainer_articleContentNewsletterWrapper__ysr46","rightRailWrapper":"articleContainer_rightRailWrapper__mnnsG","rightRail":"articleContainer_rightRail__0Sc7T","rightRailNewsletterWrapper":"articleContainer_rightRailNewsletterWrapper___oURQ","articleContent":"articleContainer_articleContent__5tm7S","contentModule":"articleContainer_contentModule__FkpWB","jump-link":"articleContainer_jump-link__NzFWL","twitter-tweet":"articleContainer_twitter-tweet__6PGw5","listicle-header":"articleContainer_listicle-header__0ncgE","articleBannerFlexContainer":"articleContainer_articleBannerFlexContainer__hx5Y_","newsJobAlertsMobile":"articleContainer_newsJobAlertsMobile__WmbSF"};

/***/ }),

/***/ 3144:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleHeader":"articleHeader_articleHeader__wIhbu","container":"articleHeader_container__kV9q2","breadCrumbLink":"articleHeader_breadCrumbLink__Uv5QC","title":"articleHeader_title__y0ohJ"};

/***/ }),

/***/ 9817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"social":"articleSocial_social__W5P_2","articleMetadata":"articleSocial_articleMetadata__LczPT","dataGroup":"articleSocial_dataGroup__jPkL9","metadataField":"articleSocial_metadataField__Ow4B5","metadataData":"articleSocial_metadataData__3lw0M","icon":"articleSocial_icon__jqfQq","facebook":"articleSocial_facebook__jzZFJ","twitter":"articleSocial_twitter__acjFr","linkedin":"articleSocial_linkedin__l7QaV","email":"articleSocial_email__wZ5nb"};

/***/ }),

/***/ 8110:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pullQuote":"blockQuote_pullQuote__7oF4k","quoteMark":"blockQuote_quoteMark__iL2jL","open":"blockQuote_open__cUp3l","close":"blockQuote_close__Prudl","richText":"blockQuote_richText__6wbnv"};

/***/ }),

/***/ 8900:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaButtons":"company_ctaButtons__ycUoM","squareButton":"company_squareButton__N_zGS","officeGrid":"company_officeGrid__oebT7","primary":"company_primary__x72ak","secondary":"company_secondary__4t4pu","tertiary":"company_tertiary__IWgHD","description":"company_description__sznTI"};

/***/ }),

/***/ 5886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__L0x8q"};

/***/ }),

/***/ 1111:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"leadMedia":"leadMedia_leadMedia__8deBJ","imageResponsive":"leadMedia_imageResponsive__rC8YL","caption":"leadMedia_caption__Yla9g","button":"leadMedia_button__R5FpS","socialIcon":"leadMedia_socialIcon__S58At","pinterest":"leadMedia_pinterest__XslBa","imagePin":"leadMedia_imagePin__2TshV"};

/***/ }),

/***/ 1536:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img":"responsiveImageModule_img__ekXHX","imgResponsive":"responsiveImageModule_imgResponsive__s4ajb","imageWrapper":"responsiveImageModule_imageWrapper__FVEW8","articleBodyImageModule":"responsiveImageModule_articleBodyImageModule__2i_XG","pullleft":"responsiveImageModule_pullleft__a_1ST","pullright":"responsiveImageModule_pullright__cTkDB","pullcenter":"responsiveImageModule_pullcenter__mxOQ2","imageRound":"responsiveImageModule_imageRound__Lv8Ze","fixed-height-container":"responsiveImageModule_fixed-height-container__sRiYZ","infographic":"responsiveImageModule_infographic__F1kw4","caption":"responsiveImageModule_caption__Uckvw"};

/***/ }),

/***/ 1719:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentModule":"sponsorModule_contentModule__hTriF","inline":"sponsorModule_inline__QDcvW","sponsorInlineLogo":"sponsorModule_sponsorInlineLogo__p2IoR","sponsorInlineEyebrow":"sponsorModule_sponsorInlineEyebrow__PfbpF","sponsorInlineTitle":"sponsorModule_sponsorInlineTitle__IiF4t","squareButton":"sponsorModule_squareButton__XcI5Y","logoPill":"sponsorModule_logoPill__glmIQ","midway":"sponsorModule_midway__ibMHN","iconMediaBlock":"sponsorModule_iconMediaBlock__h47UY","sponsor":"sponsorModule_sponsor__J42Ud","frozen":"sponsorModule_frozen___kFRM","logoWrapper":"sponsorModule_logoWrapper__ACTJ1","content":"sponsorModule_content__cmUsL","callToAction":"sponsorModule_callToAction__kTxh4","sidebar":"sponsorModule_sidebar__f0Zft","footer":"sponsorModule_footer__FKyEe"};

/***/ }),

/***/ 7985:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sponsoredRecircWidget":"sponsoredRecircWidget_sponsoredRecircWidget__3kXQB","logoPill":"sponsoredRecircWidget_logoPill__HxoSj","container":"sponsoredRecircWidget_container__1J3WP","header":"sponsoredRecircWidget_header__9rQ5A","companyImage":"sponsoredRecircWidget_companyImage__lkcsv","mainContent":"sponsoredRecircWidget_mainContent__mGBok","title":"sponsoredRecircWidget_title__pOIbs","companyName":"sponsoredRecircWidget_companyName__80M_f","footer":"sponsoredRecircWidget_footer__YnSrf","companyProfileCta":"sponsoredRecircWidget_companyProfileCta__0oidS","museLogo":"sponsoredRecircWidget_museLogo___mTNx"};

/***/ }),

/***/ 8621:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subNav":"subNav_subNav__Mb_ps","menuItem":"subNav_menuItem__injxa","menuGroup":"subNav_menuGroup__98G3_","menu":"subNav_menu__e8g05","navLink":"subNav_navLink__Qau4l","linkText":"subNav_linkText__FFkzn","mfe-sub-nav__active":"subNav_mfe-sub-nav__active__n0YRf","menuItemNested":"subNav_menuItemNested__X01Og","link":"subNav_link__jQCHH","subNavActive":"subNav_subNavActive__MfznV","title":"subNav_title__zWx5I"};

/***/ }),

/***/ 1211:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trendingSearch":"trendingSearch_trendingSearch__ejMRH","row":"trendingSearch_row__b_E4v","column":"trendingSearch_column__ag1i9","searchItem":"trendingSearch_searchItem__uyx4j","searchNumber":"trendingSearch_searchNumber__XMUMk","searchText":"trendingSearch_searchText__1abDG","searchAllJobs":"trendingSearch_searchAllJobs__X9fIU"};

/***/ }),

/***/ 4865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__zgAJj","pageHeader":"Home_pageHeader__Y8w6l","header":"Home_header__6KCIB","inputMenuOpen":"Home_inputMenuOpen__jnEXa","sidebar":"Home_sidebar__moo8u","showSidebar":"Home_showSidebar__I0bGu Home_sidebar__moo8u","content":"Home_content__f1lUf","filterToggle":"Home_filterToggle__N96mk"};

/***/ }),

/***/ 30:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"common_callToAction__Lw__1","fa-angle-right":"common_fa-angle-right__4bKwF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [734,551,850,195,190,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);